(function(){
  function boot(){
    var root = document.getElementById('passenger-fields-noapi');
    if (!root) return; if (root.__pfBound) return; root.__pfBound = true;

    var adultsInput   = root.querySelector('#pf-adults');
    var childrenInput = root.querySelector('#pf-children');
    var infantsInput  = root.querySelector('#pf-infants');
    var climateCheckbox = root.querySelector('#pf-climate-offset');
    var climatePriceEl = root.querySelector('#pf-climate-price');
    var list = root.querySelector('#pf-passenger-list');

    var propAdults     = root.querySelector('#pf-prop-adults');
    var propChildren   = root.querySelector('#pf-prop-children');
    var propInfants    = root.querySelector('#pf-prop-infants');
    var propPassengers = root.querySelector('#pf-prop-passengers');

    var totalCountEl  = root.querySelector('#pf-total-count');
    var totalPriceEl  = root.querySelector('#pf-total-price');
    var infantsNoteEl = root.querySelector('#pf-infants-note');
  var discountSummaryEl = root.querySelector('#pf-discount-summary');
  var gotlandSummaryEl  = root.querySelector('#pf-gotland-summary');

    var pfAddBtn = root.querySelector('#pf-add-to-cart');
    var pfErrEl  = root.querySelector('#pf-error');
  var pfSupportBtn = root.querySelector('#pf-support-btn');

    var productForm = root.closest('form[action*="/cart/add"], form[action="/cart/add"], product-form, form[method="post"]');
  var variantId = root.getAttribute('data-variant-id');
  var _urlProps = null, _variantMap = null, _discountCode = null, _moneyFmt = null;

  // -- START NEW LOGIC: Resolve variants dynamically --
  var allVariants = [];
  try {
    var vdata = document.getElementById('pf-variants-data');
    if(vdata) allVariants = JSON.parse(vdata.textContent);
  } catch(e){}

  // -- Gotland-rabatt-produkt (id 15830335816011) variants --
  var gotlandVariants = [];
  var _gotlandVariantMap = null;
  try {
    var gvdata = document.getElementById('pf-gotland-variants-data');
    if (gvdata) {
      var gvtxt = (gvdata.textContent || '').trim();
      if (gvtxt) gotlandVariants = JSON.parse(gvtxt);
    }
  } catch(e){ gotlandVariants = []; }
  if (!Array.isArray(gotlandVariants)) gotlandVariants = [];

  // Gotlandsrabatt giltighetsperiod — ändra dessa två datum (YYYY-MM-DD) för att förlänga/ändra kampanjen.
  // Hela resan (utresa och ev. returresa) måste ligga inom intervallet, annars erbjuds ingen rabatt alls.
  var GOTLAND_DISCOUNT_VALID_FROM = '2026-01-01';
  var GOTLAND_DISCOUNT_VALID_UNTIL = '2026-12-31';

  function _isWithinGotlandDiscountPeriod(ymd) {
    var s = String(ymd || '').slice(0, 10);
    return !!s && s >= GOTLAND_DISCOUNT_VALID_FROM && s <= GOTLAND_DISCOUNT_VALID_UNTIL;
  }

  // Hela resan måste kvalificera — om ena benet ligger utanför perioden erbjuds ingen rabatt,
  // inte ens för det ben som ligger inom perioden.
  function tripQualifiesForGotlandDiscount() {
    var pp = getUrlProps();
    var outLegDate = pp.outboundDate || pp.date || '';
    var retLegDate = pp.returnDate || '';
    if (!_isWithinGotlandDiscountPeriod(outLegDate)) return false;
    if (retLegDate && !_isWithinGotlandDiscountPeriod(retLegDate)) return false;
    return true;
  }

  // Helper: Get URL props (using the function defined below via hoisting)
  var p = getUrlProps();
  
  // 1. Determine Route (VB vs VG)
  var routeCode = 'VB'; 
  var origin = (p.origin || '').toUpperCase();
  var dir = (p.direction || p.outboundDirection || '').toUpperCase();
  if (origin === 'GOT' || dir.indexOf('GOT') !== -1 || dir.indexOf('GÖTEBORG') !== -1) {
    routeCode = 'VG';
  }

  // 2. Determine Trip (Always map TR -> Enkel products, but track TR intent)
  var tripCode = 'Enkel';
  var tt = (p.tripType || '').toLowerCase();
  var isRoundTripReal = false;
  if (tt.indexOf('round') !== -1 || tt.indexOf('tur') !== -1 || tt.indexOf('return') !== -1) {
    isRoundTripReal = true;
    tripCode = 'Enkel'; // Force Enkel products even for round-trip
  }

  // 3. Determine Class/Offer overrides
  var qOut = (p.rbdQActiveOutbound === 'true');
  var qRet = (p.rbdQActiveReturn === 'true');
  var qSingle = (p.rbdQActiveSingle === 'true');

  var isQLimit2 = (isRoundTripReal && qOut && qRet);
  var isQLimit1 = (isRoundTripReal && (qOut || qRet) && !isQLimit2) || (!isRoundTripReal && qSingle);

  var isK = (p.rbdKActiveSingle === 'true' || p.rbdKActiveOutbound === 'true' || p.rbdKActiveReturn === 'true');
  var isUMBooking = (p.rbdUActiveSingle === 'true' || p.rbdUActiveOutbound === 'true' || p.rbdUActiveReturn === 'true');

  function normalizeVariantTitle(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, '')
      .trim();
  }

  function findV(typeSuffix) {
    if (!_variantMap) {
      _variantMap = {};
      allVariants.forEach(function(v){ _variantMap[normalizeVariantTitle(v.title)] = v; });
    }
    var wanted = normalizeVariantTitle(routeCode + '-' + tripCode + '-' + typeSuffix);
    var direct = _variantMap[wanted];
    if (direct) return direct;

    // Alias/fallback for class naming differences in Shopify
    if (typeSuffix === 'Kampanj') {
      var aliasMatch = _variantMap[normalizeVariantTitle(routeCode + '-' + tripCode + '-Silver')];
      if (aliasMatch) return aliasMatch;
    }

    return null;
  }

  // === Gotland-rabatt-produkt: variant-uppslag baserat på titel ===
  function buildGotlandVariantMap() {
    if (_gotlandVariantMap) return _gotlandVariantMap;
    _gotlandVariantMap = {};
    gotlandVariants.forEach(function(v){
      _gotlandVariantMap[normalizeVariantTitle(v.title)] = v;
    });
    return _gotlandVariantMap;
  }
  function hasGotlandVariants(){ return gotlandVariants && gotlandVariants.length > 0; }
  // Hitta motsvarande variant i Gotland-rabatt-produkten med samma titel
  function gotlandVariantForOriginalId(originalVariantId) {
    if (!originalVariantId || !hasGotlandVariants()) return null;
    var orig = allVariants.find(function(v){ return Number(v.id) === Number(originalVariantId); });
    if (!orig) return null;
    var map = buildGotlandVariantMap();
    return map[normalizeVariantTitle(orig.title)] || null;
  }

  // Resolve Variant Ojbects
  var vAdult = null;
  if (isK) vAdult = findV('Kampanj');
  else if (isQLimit2) vAdult = findV('QLIMIT2');
  else if (isQLimit1) vAdult = findV('QLIMIT');
  if (!vAdult) vAdult = findV('Vuxen'); // Fallback to standard
  
  var vChild = findV('Barn');
  
  var vSenior = null;
  if (isK) vSenior = findV('Kampanj');
  // else if (isQLimit2) vSenior = findV('QLIMIT2'); // QLIMIT handled per leg now
  // else if (isQLimit1) vSenior = findV('QLIMIT');
  if (!vSenior) vSenior = findV('Reduced'); // Senior maps to Reduced
  if (!vSenior) vSenior = findV('Senior'); // Backup
  if (!vSenior) vSenior = vAdult;

  var vYouth = null;
  if (isK) vYouth = findV('Kampanj');
  // else if (isQLimit2) vYouth = findV('QLIMIT2');
  // else if (isQLimit1) vYouth = findV('QLIMIT');
  if (!vYouth) vYouth = findV('Reduced'); // Youth maps to Reduced
  if (!vYouth) vYouth = findV('Youth'); // Backup
  if (!vYouth) vYouth = vAdult;


  var vKampanj = findV('Kampanj');
  var vVBX = findV('VB-X');
  // Cross-route fallback: if VG-Enkel-VB-X doesn't exist yet in Shopify,
  // find any variant ending '-VB-X' (e.g. VB-Enkel-VB-X from the same product).
  // Long-term fix: add a 'VG-Enkel-VB-X' variant to the boka product in Shopify admin.
  if (!vVBX) {
    vVBX = allVariants.find(function(v){ return v.title.toLowerCase().endsWith('-vb-x'); });
  }

  // Assign IDs and Prices
  var adultVariantId = vAdult ? vAdult.id : variantId;
  var childVariantId = vChild ? vChild.id : variantId;
  var seniorVariantId = vSenior ? vSenior.id : adultVariantId;
  var youthVariantId = vYouth ? vYouth.id : adultVariantId;
  var campaignChildVariantId = childVariantId;
  var vbxVariantId = vVBX ? vVBX.id : adultVariantId;

  var adultUnitPriceCents = vAdult ? vAdult.price : 199500;
  var childUnitPriceCents = vChild ? vChild.price : 99500;
  var vbxUnitPriceCents = vVBX ? vVBX.price : 449000;

  // Customer tag driven eligibility for Senior/Youth pricing (applied to contact person only)
  var customerTags = (root.getAttribute('data-customer-tags') || '').split(/[,]/).map(function(s){ return s.trim().toUpperCase(); }).filter(Boolean);
  var isLoggedIn = !!(root.getAttribute('data-customer-first') || root.getAttribute('data-customer-email'));
  // Support both 'SENIOR' and 'Senior' spellings, and 'RABATT' tag as eligible. Tags are uppercased above.
  var isSeniorCustomer = (customerTags.indexOf('PENSIONÄR') !== -1) || (customerTags.indexOf('SENIOR') !== -1);
  var isYouthCustomer  = (customerTags.indexOf('UNGDOM') !== -1) || (customerTags.indexOf('YOUTH') !== -1) || (customerTags.indexOf('STUDENT') !== -1);
  var isDiscountTag    = (customerTags.indexOf('RABATT') !== -1);
  var isReducedEligible = isSeniorCustomer || isYouthCustomer || isDiscountTag;
  // Tag '09' = kund folkbokförd på Gotland (automatisk Gotland-rabatt på kontaktpersonen)
  var isGotlandCustomer = isLoggedIn && customerTags.indexOf('09') !== -1;

    var currency = (root.getAttribute('data-currency') || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'SEK').toUpperCase();
    var locale = document.documentElement.lang || 'sv-SE';

    var afterAdd = 'cart';

    // Detect touch/mobile vs desktop (coarse pointer = likely mobile)
    var isTouch = (window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches) || /Mobi|Android/i.test(navigator.userAgent);

    // Mobile numeric picker state
    var pickerBackdrop, pickerGrid, pickerTitle, pickerCloseBtn, pickerClearBtn, pickerTarget = null;

    function ensurePicker(){
      if (pickerBackdrop) return;
      pickerBackdrop = document.createElement('div');
      pickerBackdrop.className = 'pf-numpicker-backdrop';
      pickerBackdrop.innerHTML = ''+
        '<div class="pf-numpicker" role="dialog" aria-modal="true" aria-labelledby="pf-numpicker-title">\n'
      + '  <div id="pf-numpicker-title" class="pf-numpicker-title">Välj antal</div>\n'
      + '  <div class="pf-numpicker-grid"></div>\n'
      + '  <div class="pf-numpicker-actions">\n'
      + '    <button type="button" class="pf-numpicker-clear">Rensa</button>\n'
      + '    <button type="button" class="pf-numpicker-close">Stäng</button>\n'
      + '  </div>\n'
      + '</div>';
      document.body.appendChild(pickerBackdrop);
      pickerGrid = pickerBackdrop.querySelector('.pf-numpicker-grid');
      pickerTitle = pickerBackdrop.querySelector('#pf-numpicker-title');
      pickerCloseBtn = pickerBackdrop.querySelector('.pf-numpicker-close');
      pickerClearBtn = pickerBackdrop.querySelector('.pf-numpicker-clear');

  // Build number buttons 1–9 (0 kan väljas via "Rensa")
  var nums = [0,1,2,3,4,5,6,7,8,9];
      nums.forEach(function(n){
        var b=document.createElement('button');
        b.type='button'; b.className='pf-numpicker-btn'; b.textContent=String(n);
        b.addEventListener('click', function(){ if(!pickerTarget) return; pickerTarget.value = String(n); pickerHide(); render(); });
        pickerGrid.appendChild(b);
      });
      function onClose(){ pickerHide(); }
      function onClear(){ if(pickerTarget){ pickerTarget.value='0'; } pickerHide(); render(); }
      pickerCloseBtn.addEventListener('click', onClose);
      pickerClearBtn.addEventListener('click', onClear);
      pickerBackdrop.addEventListener('click', function(e){ if(e.target === pickerBackdrop) onClose(); });
    }

    function pickerShow(target, title){ ensurePicker(); pickerTarget = target; if (pickerTitle) pickerTitle.textContent = title || 'Välj antal'; pickerBackdrop.style.display='flex'; document.body.style.overflow='hidden'; }
    function pickerHide(){ if (pickerBackdrop) pickerBackdrop.style.display='none'; document.body.style.overflow=''; pickerTarget=null; }

    function setDesktopInputs(){
      [adultsInput, childrenInput, infantsInput].forEach(function(inp){ if(!inp) return; inp.readOnly=false; inp.type='number'; inp.min='0'; inp.step='1'; inp.max='9'; inp.removeEventListener('click', onMobileInputClick); });
      pickerHide();
    }
    function inputLabelById(id){
      switch(id){
        case 'pf-adults': return 'Antal vuxna';
        case 'pf-children': return 'Antal barn';
        case 'pf-infants': return 'Antal spädbarn';
        default: return 'Välj antal';
      }
    }
    function onMobileInputClick(e){ var t=e.currentTarget; pickerShow(t, inputLabelById(t.id)); }
    function setMobileInputs(){
      ensurePicker();
      [adultsInput, childrenInput, infantsInput].forEach(function(inp){ if(!inp) return; inp.type='text'; inp.readOnly=true; inp.inputMode='numeric'; inp.setAttribute('pattern','[0-9]*'); inp.addEventListener('click', onMobileInputClick); });
    }

    function findThemeAddButton(){ if (productForm) return productForm.querySelector('button.product-form__submit[name="add"], button[name="add"], [type="submit"]'); return document.querySelector('button.product-form__submit[name="add"], button[name="add"]'); }
    function findQuantityInput(){ if (productForm) return productForm.querySelector('input[name="quantity"], quantity-input input[type="number"], .quantity__input, .quantity input[type="number"]'); return document.querySelector('form[action*="/cart/add"] input[name="quantity"]'); }
    var themeAddBtn = findThemeAddButton();
    var qtyInput = findQuantityInput();

    function clampNum(v, min, max){ var n = Math.max(min, Math.min(max, parseInt(v||0,10))); return isFinite(n) ? n : 0; }
    function formatMoney(cents){ try { return new Intl.NumberFormat(locale, { style:'currency', currency: currency }).format((cents||0)/100); } catch(e){ return ((cents||0)/100).toFixed(2) + ' ' + currency; } }
    function formatMoneySignedNegative(cents){
      // Always display as a negative amount (e.g., -2 000,00 kr)
      try { return '-' + new Intl.NumberFormat(locale, { style:'currency', currency: currency }).format((cents||0)/100); } catch(e){ return '-' + ((cents||0)/100).toFixed(2) + ' ' + currency; }
    }
    function getUrlDiscountCode(){ if (_discountCode !== null) return _discountCode; try { var sp=new URLSearchParams(window.location.search); _discountCode = sp.get('discount') || ''; } catch(_){ _discountCode = ''; } return _discountCode; }
    function normalizeCode(s){ return String(s||'').trim().toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g,''); }
    function sanitizeSwedishNameChars(s){
      return String(s||'')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[ÅÄåä]/g, 'A')
        .replace(/[Öö]/g, 'O');
    }
    function sanitizePassengerNameFields(passengers){
      if (!Array.isArray(passengers)) return passengers;
      passengers.forEach(function(p){
        if (!p || typeof p !== 'object') return;
        if (p.firstName !== undefined) p.firstName = sanitizeSwedishNameChars(p.firstName);
        if (p.lastName !== undefined) p.lastName = sanitizeSwedishNameChars(p.lastName);
      });
      return passengers;
    }
    function logPassengerNameSanitization(context, passengers){
      try {
        if (!window.console || !console.log || !Array.isArray(passengers)) return;
        console.groupCollapsed('[pf-noapi] ' + context + ' – namn-sanering');
        passengers.forEach(function(p, idx){
          if (!p || typeof p !== 'object') return;
          var originalFirst = p.firstName;
          var originalLast = p.lastName;
          var sanitizedFirst = sanitizeSwedishNameChars(originalFirst);
          var sanitizedLast = sanitizeSwedishNameChars(originalLast);
          console.log(
            '#' + (idx + 1) + ' ' + String(p.type || '').toUpperCase(),
            { firstName: originalFirst, firstNameSanitized: sanitizedFirst, lastName: originalLast, lastNameSanitized: sanitizedLast }
          );
        });
        console.groupEnd();
      } catch(_) {}
    }
    // Parse generic discount suffixes:
    //  - ...P50  => 50% off per paying ticket (adults + children)
    //  - ...A500 => 500 SEK off per paying ticket (capped at the ticket price)
    function parseSimpleDiscount(code){
      var c = normalizeCode(code);
      if (!c) return null;
      var m = c.match(/([PA])(\d{1,4})$/);
      if (!m) return null;
      var kind = (m[1] === 'P') ? 'percent' : 'amount';
      var value = parseInt(m[2], 10);
      if (!isFinite(value) || value <= 0) return null;
      return { kind: kind, value: value };
    }
    var _htmlEsc = {'&':'&amp;','<':'&lt;','>':'&gt;'};
    function escapeHtml(t){ return String(t||'').replace(/[&<>]/g, function(c){ return _htmlEsc[c]; }); }
    function showError(msg){
      if(!pfErrEl) return;
      pfErrEl.style.display = msg ? 'block' : 'none';
      pfErrEl.textContent = msg || '';
    }
    function showErrorHtml(html){
      if(!pfErrEl) return;
      pfErrEl.style.display = html ? 'block' : 'none';
      pfErrEl.innerHTML = html || '';
    }
    function showSupportBtn(show){ if (!pfSupportBtn) return; pfSupportBtn.style.display = show ? 'inline-block' : 'none'; }
    function showContinueToCartDialog(onConfirm){
      try {
        var existing = document.getElementById('pf-continue-cart-dialog');
        if (existing) existing.remove();

        var backdrop = document.createElement('div');
        backdrop.id = 'pf-continue-cart-dialog';
        backdrop.style.position = 'fixed';
        backdrop.style.inset = '0';
        backdrop.style.zIndex = '999999';
        backdrop.style.background = 'rgba(0,0,0,.55)';
        backdrop.style.display = 'flex';
        backdrop.style.alignItems = 'center';
        backdrop.style.justifyContent = 'center';
        backdrop.style.padding = '20px';

        var modal = document.createElement('div');
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-modal', 'true');
        modal.style.width = 'min(92vw, 520px)';
        modal.style.background = '#fff';
        modal.style.borderRadius = '16px';
        modal.style.boxShadow = '0 20px 60px rgba(0,0,0,.35)';
        modal.style.padding = '24px';
        modal.style.fontFamily = 'inherit';

        var title = document.createElement('h2');
        title.textContent = 'Bokningen är skapad';
        title.style.margin = '0 0 12px';
        title.style.fontSize = '1.6rem';

        var text = document.createElement('p');
        text.textContent = 'Bokningen och varukorgen är skapade. Klicka vidare till kassan när du är redo att läsa console-loggen.';
        text.style.margin = '0 0 20px';
        text.style.lineHeight = '1.5';

        var actions = document.createElement('div');
        actions.style.display = 'flex';
        actions.style.gap = '12px';
        actions.style.justifyContent = 'flex-end';
        actions.style.flexWrap = 'wrap';

        var stayBtn = document.createElement('button');
        stayBtn.type = 'button';
        stayBtn.textContent = 'Stanna kvar';
        stayBtn.style.padding = '12px 16px';
        stayBtn.style.border = '1px solid #ccc';
        stayBtn.style.background = '#fff';
        stayBtn.style.borderRadius = '10px';
        stayBtn.style.cursor = 'pointer';

        var confirmBtn = document.createElement('button');
        confirmBtn.type = 'button';
        confirmBtn.textContent = 'Gå till kassan';
        confirmBtn.style.padding = '12px 16px';
        confirmBtn.style.border = 'none';
        confirmBtn.style.background = '#0f6fff';
        confirmBtn.style.color = '#fff';
        confirmBtn.style.borderRadius = '10px';
        confirmBtn.style.cursor = 'pointer';

        function close(){
          if (backdrop && backdrop.parentNode) backdrop.parentNode.removeChild(backdrop);
          document.removeEventListener('keydown', onKeyDown, true);
        }
        function onConfirmClick(){
          close();
          if (typeof onConfirm === 'function') onConfirm();
        }
        function onKeyDown(e){
          if (e.key === 'Escape') {
            e.preventDefault();
            close();
          }
        }

        backdrop.addEventListener('click', function(e){ if (e.target === backdrop) close(); });
        stayBtn.addEventListener('click', close);
        confirmBtn.addEventListener('click', onConfirmClick);
        document.addEventListener('keydown', onKeyDown, true);

        actions.appendChild(stayBtn);
        actions.appendChild(confirmBtn);
        modal.appendChild(title);
        modal.appendChild(text);
        modal.appendChild(actions);
        backdrop.appendChild(modal);
        document.body.appendChild(backdrop);
        confirmBtn.focus();
      } catch(_) {
        if (typeof onConfirm === 'function') onConfirm();
      }
    }

    // Landskoder för telefon (sökbar via datalist)
    var COUNTRY_CODES = [
      { code:'46', name:'Sverige' },
      { code:'47', name:'Norge' },
      { code:'45', name:'Danmark' },
      { code:'358', name:'Finland' },
      { code:'354', name:'Island' },
      { code:'49', name:'Tyskland' },
      { code:'31', name:'Nederländerna' },
      { code:'32', name:'Belgien' },
      { code:'33', name:'Frankrike' },
      { code:'34', name:'Spanien' },
      { code:'39', name:'Italien' },
      { code:'44', name:'Storbritannien' },
      { code:'353', name:'Irland' },
      { code:'48', name:'Polen' },
      { code:'370', name:'Litauen' },
      { code:'371', name:'Lettland' },
      { code:'372', name:'Estland' },
      { code:'1', name:'USA/Kanada' },
      { code:'90', name:'Turkiet' },
      { code:'66', name:'Thailand' }
    ];
    var countryCodeDatalistId = 'pf-country-codes-list';
    var COUNTRY_CODE_SET = COUNTRY_CODES.reduce(function(acc, c){ acc[c.code] = true; return acc; }, {});
    var COUNTRY_CODE_MAP  = COUNTRY_CODES.reduce(function(acc, c){ acc[c.code] = c; return acc; }, {});

    function countryLabelByCode(code){
      var c = String(code||'').replace(/\D+/g,'');
      var found = COUNTRY_CODE_MAP[c];
      return found ? (found.name + ' (+' + found.code + ')') : ('+' + c);
    }
    function countryShortByCode(code){
      var c = String(code||'').replace(/\D+/g,'');
      return '+' + (c || '46');
    }
    function parseCountryCodeValue(v){
      var s = String(v||'').trim();
      if (!s) return '';
      var digits = s.replace(/\D+/g,'');
      if (digits) {
        // Exact known country code
        if (COUNTRY_CODE_SET[digits]) return digits;
        // Prefix match against known codes (prevents +467 from becoming invalid 467)
        var best = '';
        for (var i0 = 0; i0 < COUNTRY_CODES.length; i0++) {
          var c0 = COUNTRY_CODES[i0].code;
          if (digits.indexOf(c0) === 0 && c0.length > best.length) best = c0;
        }
        if (best) return best;
      }
      var n = normalizeCode(s).replace(/[^A-Z]/g,'');
      for (var i=0; i<COUNTRY_CODES.length; i++){
        var cc = COUNTRY_CODES[i];
        var nn = normalizeCode(cc.name).replace(/[^A-Z]/g,'');
        if (nn.indexOf(n) !== -1 || n.indexOf(nn) !== -1) return cc.code;
      }
      return '';
    }
    function ensureCountryCodeDatalist(){
      var dl = document.getElementById(countryCodeDatalistId);
      if (dl) return dl;
      dl = document.createElement('datalist');
      dl.id = countryCodeDatalistId;
      COUNTRY_CODES.forEach(function(c){
        var o = document.createElement('option');
        o.value = c.name + ' (+' + c.code + ')';
        dl.appendChild(o);
      });
      document.body.appendChild(dl);
      return dl;
    }

    function field(cfg){ var w = document.createElement('label'); w.className = 'pf-field'; var s = document.createElement('span'); s.textContent = cfg.label + (cfg.required ? ' *' : ''); if(cfg.required){ var star=document.createElement('span'); star.className='pf-req'; s.appendChild(star); } w.appendChild(s); var i = document.createElement('input'); i.type=cfg.type||'text'; if(cfg.min!==undefined) i.min=cfg.min; if(cfg.max!==undefined) i.max=cfg.max; i.required=!!cfg.required; i.setAttribute('data-name', cfg.name); var auto = cfg.autocomplete; if(!auto){ switch(cfg.name){ case 'firstName': auto='given-name'; break; case 'lastName': auto='family-name'; break; case 'email': auto='email'; break; case 'phone': auto='tel'; break; case 'age': auto='off'; break; default: auto='off'; } } i.name = 'passenger_' + cfg.name; i.autocomplete = auto; if(cfg.name==='phone') i.inputMode='tel'; if(cfg.name==='age') i.inputMode='numeric'; w.appendChild(i); if(cfg.hint){ var h=document.createElement('div'); h.className='pf-hint'; h.textContent=cfg.hint; w.appendChild(h); } return w; }
    function select(cfg){
      var w = document.createElement('label');
      w.className = 'pf-field';
      var s = document.createElement('span');
      s.textContent = cfg.label + (cfg.required ? ' *' : '');
      w.appendChild(s);
      var sel = document.createElement('select');
      sel.required = !!cfg.required;
      sel.setAttribute('data-name', cfg.name);
      sel.name = 'passenger_' + cfg.name;
      sel.autocomplete = (cfg.name === 'gender') ? 'sex' : 'off';
      // Add a placeholder option (not selectable as a valid value)
      if (cfg.placeholder) {
        var ph = document.createElement('option');
        ph.value = '';
        ph.textContent = cfg.placeholder;
        ph.disabled = true;
        ph.selected = true;
        sel.appendChild(ph);
      }
      for (var k = 0; k < cfg.options.length; k++){
        var o = cfg.options[k];
        var op = document.createElement('option');
        op.value = o.value;
        op.textContent = o.text;
        sel.appendChild(op);
      }
      w.appendChild(sel);
      return w;
    }
    function phoneField(cfg){
      try { ensureCountryCodeDatalist(); } catch(_) {}
      var w = document.createElement('label');
      w.className = 'pf-field pf-phone-field';
      var s = document.createElement('span');
      s.textContent = cfg.label + (cfg.required ? ' *' : '');
      w.appendChild(s);

      var row = document.createElement('div');
      row.className = 'pf-phone-row';
      row.style.display = 'flex';
      row.style.gap = '8px';
      row.style.alignItems = 'center';

      var countryVisible = document.createElement('input');
      countryVisible.type = 'text';
      countryVisible.className = 'pf-country-code-visible';
      countryVisible.setAttribute('list', countryCodeDatalistId);
      countryVisible.setAttribute('data-country-display', 'true');
      countryVisible.value = countryShortByCode('46');
      countryVisible.autocomplete = 'off';
      countryVisible.setAttribute('aria-label', 'Landskod');
      countryVisible.style.maxWidth = '96px';
      countryVisible.style.flex = '0 0 96px';
      countryVisible.style.minWidth = '96px';
      countryVisible.style.textAlign = 'center';

      var countryHidden = document.createElement('input');
      countryHidden.type = 'hidden';
      countryHidden.setAttribute('data-name', 'phoneCountryCode');
      countryHidden.name = 'passenger_phoneCountryCode';
      countryHidden.value = '46';

      var phone = document.createElement('input');
      phone.type = 'tel';
      phone.required = !!cfg.required;
      phone.setAttribute('data-name', 'phone');
      phone.name = 'passenger_phone';
      phone.autocomplete = 'tel-national';
      phone.inputMode = 'tel';
      phone.style.flex = '1 1 auto';

      row.appendChild(countryVisible);
      row.appendChild(countryHidden);
      row.appendChild(phone);
      w.appendChild(row);
      return w;
    }
    function buildPassenger(type, num, opts){
      var isAdult = type === 'Vuxen';
      var includeContact = !!(opts && opts.includeContact);
      var wrapper=document.createElement('div'); wrapper.className='pf-passenger';
      var title=document.createElement('h3'); title.textContent = type + ' #' + num; wrapper.appendChild(title);

      var line=document.createElement('div'); line.className='pf-line';
      line.appendChild(field({ label:'Förnamn', name:'firstName', required:isAdult }));
      line.appendChild(field({ label:'Efternamn', name:'lastName', required:isAdult }));
      line.appendChild(select({ label:'Kön', name:'gender', required:isAdult, placeholder:'Välj...', options:[
        {value:'Man',text:'Man'},{value:'Kvinna',text:'Kvinna'},{value:'Annat',text:'Annat'}
      ]}));

      // Om inloggad är berättigad (Senior/Student), ge möjlighet att markera medföljande vuxna som också berättigade
      // Men bara om rutten tillåter R-klass
      var rActive = false;
      try {
          var p2 = getUrlProps();
          var tt2 = (p2.tripType||'').toLowerCase();
          if (tt2 === 'single') { rActive = String(p2.rbdRActiveSingle||'').toLowerCase() === 'true'; }
          else {
            var outR = String(p2.rbdRActiveOutbound||'').toLowerCase() === 'true';
            var retR = String(p2.rbdRActiveReturn||'').toLowerCase() === 'true';
            rActive = outR || retR;
          }
      } catch(_){}

      if (isAdult && num > 1 && isReducedEligible && rActive) {
        var chkLabel = document.createElement('label');
        chkLabel.className = 'pf-field pf-checkbox-field';
        chkLabel.style.flexDirection = 'row';
        chkLabel.style.alignItems = 'center';
        chkLabel.style.fontSize = '1.4rem';
        var chk = document.createElement('input');
        chk.type = 'checkbox';
        chk.setAttribute('data-name', 'isReduced');
        chk.style.width = '20px';
        chk.style.height = '20px';
        chk.style.marginRight = '8px';
        chk.style.appearance = 'auto';
        chk.style.webkitAppearance = 'auto';
        chk.style.padding = '0';
        chk.style.border = 'initial';
        chk.style.flex = 'none';
        chkLabel.appendChild(chk);
        var txt = document.createTextNode(isSeniorCustomer ? 'Är också pensionär?' : (isYouthCustomer ? 'Är också ungdom/student?' : 'Har också rabatt?'));
        chkLabel.appendChild(txt);
        line.appendChild(chkLabel);
      }

      if(opts.requireAge){
        // Barn måste vara 2–12 år
        line.appendChild(field({ label:'Ålder', name:'age', type:'number', min:2, max:12, required:true, hint:'Ålder 2–12 år' }));
      }
      line.setAttribute('data-fields', opts.requireAge ? '4' : '3');
      wrapper.appendChild(line);

      if (includeContact) {
        var contact=document.createElement('div'); contact.className='pf-line-contact';
        var contactRequired = isAdult; // endast första vuxen kommer ha includeContact=true
        contact.appendChild(phoneField({ label:'Telefon', name:'phone', required:contactRequired, type:'tel' }));
        contact.appendChild(field({ label:'E-post', name:'email', required:contactRequired, type:'email' }));
        wrapper.appendChild(contact);
      }

      if (type === 'Barn') {
        var childNote = document.createElement('p');
        childNote.style.cssText = 'font-size:13px;color:#c0392b;margin:0 0 8px;';
        childNote.textContent = 'Observera att barn måste resa tillsammans med en person som är 16 år eller äldre, annars krävs ledsagare. ';
        var childNoteLink = document.createElement('a');
        childNoteLink.href = 'https://brommaflyg.se/pages/ensamakande-barn';
        childNoteLink.target = '_blank';
        childNoteLink.rel = 'noopener noreferrer';
        childNoteLink.textContent = 'Läs mer här';
        childNoteLink.style.cssText = 'color:inherit;text-decoration:underline;';
        childNote.appendChild(childNoteLink);
        wrapper.appendChild(childNote);
      }

      wrapper.dataset.pfType=type;
      return wrapper;
    }

    function buildContactCard(){
      var wrapper = document.createElement('div');
      wrapper.className = 'pf-passenger';
      wrapper.dataset.pfType = 'Kontaktperson';
      var h3 = document.createElement('h3');
      h3.textContent = 'Kontaktperson (reser inte med)';
      wrapper.appendChild(h3);
      var note = document.createElement('p');
      note.style.cssText = 'font-size:13px;color:#666;margin:0 0 8px;';
      note.textContent = 'Kontaktpersonen är ansvarig vuxen men reser inte med. Fyll i kontaktuppgifter.';
      wrapper.appendChild(note);
      var line = document.createElement('div');
      line.className = 'pf-line';
      line.appendChild(field({ label:'Förnamn', name:'firstName', required:true }));
      line.appendChild(field({ label:'Efternamn', name:'lastName', required:true }));
      line.appendChild(select({ label:'Kön', name:'gender', required:true, placeholder:'Välj...', options:[
        {value:'Man',text:'Man'},{value:'Kvinna',text:'Kvinna'},{value:'Annat',text:'Annat'}
      ]}));
      line.setAttribute('data-fields', '3');
      wrapper.appendChild(line);
      var contact = document.createElement('div');
      contact.className = 'pf-line-contact';
      contact.appendChild(phoneField({ label:'Telefon', name:'phone', required:true, type:'tel' }));
      contact.appendChild(field({ label:'E-post', name:'email', required:true, type:'email' }));
      wrapper.appendChild(contact);
      return wrapper;
    }

    // Telefonmask och normalisering
    function digitsOnly(s){ return String(s||'').replace(/\D+/g,''); }
    function formatPhoneDisplay(digs, countryCode){
      var d = digitsOnly(digs || '');
      var cc = String(countryCode||'').replace(/\D+/g,'');

      // Sverige (+46): trunkprefix 0 tas bort och format 72-720 97 98
      if (cc === '46') {
        d = d.replace(/^0+/, '').slice(0, 9);
        var n = d.length;
        if (n <= 2) return d; // XX
        if (n <= 5) return d.slice(0,2) + '-' + d.slice(2); // XX-XXX
        if (n <= 7) return d.slice(0,2) + '-' + d.slice(2,5) + ' ' + d.slice(5); // XX-XXX XX
        return d.slice(0,2) + '-' + d.slice(2,5) + ' ' + d.slice(5,7) + ' ' + d.slice(7); // XX-XXX XX XX
      }

      // Fallback för övriga länder
      d = d.slice(0, 12);
      var m = d.length;
      if (m <= 3) return d;
      if (m <= 6) return d.slice(0,3) + '-' + d.slice(3);
      if (m <= 8) return d.slice(0,3) + '-' + d.slice(3,6) + ' ' + d.slice(6);
      if (m <= 10) return d.slice(0,3) + '-' + d.slice(3,6) + ' ' + d.slice(6,8) + ' ' + d.slice(8);
      return d;
    }
    function getCountryCodeFromPhoneInput(phoneInput){
      var card = phoneInput && phoneInput.closest('.pf-passenger');
      if (!card) return '46';
      var h = card.querySelector('input[data-name="phoneCountryCode"]');
      var c = h ? String(h.value||'').replace(/\D+/g,'') : '';
      return c || '46';
    }
    function bindCountryCodeInputs(){
      try {
        list.querySelectorAll('input[data-country-display="true"]').forEach(function(inp){
          var card = inp.closest('.pf-passenger');
          if (!card) return;
          var hidden = card.querySelector('input[data-name="phoneCountryCode"]');
          if (!hidden) return;

          function syncFromText(){
            var parsed = parseCountryCodeValue(inp.value);
            if (!parsed) parsed = String(hidden.value||'').replace(/\D+/g,'') || '46';
            hidden.value = parsed;
            inp.value = countryShortByCode(parsed);

            var p = card.querySelector('input[data-name="phone"]');
            if (p && p.value) p.value = formatPhoneDisplay(p.value, parsed);
          }

          // init from hidden
          var initCode = String(hidden.value||'').replace(/\D+/g,'') || '46';
          hidden.value = initCode;
          inp.value = countryShortByCode(initCode);
          inp.setAttribute('placeholder', countryShortByCode(initCode));

          inp.addEventListener('focus', function(){
            // Make datalist searchable by country name on click/focus
            if (/^\+\d{1,3}$/.test(String(inp.value||''))) inp.value = '';
          });

          inp.addEventListener('change', syncFromText);
          inp.addEventListener('blur', syncFromText);
        });
      } catch(_) {}
    }
    function bindPhoneMask(){
      var phones = list.querySelectorAll('input[data-name="phone"]');
      phones.forEach(function(inp){
        // Initiera display-format
        if (inp.value) inp.value = formatPhoneDisplay(inp.value, getCountryCodeFromPhoneInput(inp));
        // Begränsa tangenttryckningar
        inp.addEventListener('keydown', function(e){
          var k = e.key || '';
          if (k === '+') { e.preventDefault(); return; }
          if (k === ' ' || k === '-' || k === 'Spacebar') { e.preventDefault(); return; }
          var allowed = ['Backspace','Delete','ArrowLeft','ArrowRight','Home','End','Tab'];
          if (allowed.indexOf(k) !== -1) return;
          if (/^\d$/.test(k)) return; // siffror ok
          if (e.ctrlKey || e.metaKey) return; // allow copy paste shortcuts
          e.preventDefault();
        });
        function reformat(){ inp.value = formatPhoneDisplay(inp.value, getCountryCodeFromPhoneInput(inp)); }
        inp.addEventListener('input', reformat);
        inp.addEventListener('blur', reformat);
        inp.addEventListener('paste', function(ev){
          ev.preventDefault();
          var txt = (ev.clipboardData && ev.clipboardData.getData('text')) || '';
          inp.value = formatPhoneDisplay(txt, getCountryCodeFromPhoneInput(inp));
        });
      });
    }
    function normalizeAllPhoneFields(){
      try {
        list.querySelectorAll('input[data-name="phone"]').forEach(function(inp){
          if (!inp) return;
          var cc = getCountryCodeFromPhoneInput(inp);
          inp.value = formatPhoneDisplay(inp.value || '', cc);
        });
      } catch(_) {}
    }

    function prefillCustomer(){
      var first = root.dataset.customerFirst;
      var last  = root.dataset.customerLast;
      var email = root.dataset.customerEmail;
      var phone = root.dataset.customerPhone;
      if(!first && !last && !email && !phone) return;
      var adultCard = list.querySelector('.pf-passenger[data-pf-type="Vuxen"]');
      if(!adultCard) return;
      function setIfEmpty(sel,val){ if(!val) return; var el=adultCard.querySelector(sel); if(el && !el.value) el.value=val; }
      setIfEmpty('[data-name="firstName"]', first);
      setIfEmpty('[data-name="lastName"]',  last);
      setIfEmpty('[data-name="email"]',     email);
      
      // Prefill phone if available, applying formatting + landskod
      if (phone) {
        var parsedPhone = splitPhone(phone);
        var ccEl = adultCard.querySelector('input[data-name="phoneCountryCode"]');
        var ccDisplayEl = adultCard.querySelector('input[data-country-display="true"]');
        var telEl = adultCard.querySelector('[data-name="phone"]');
        if (ccEl) ccEl.value = parsedPhone.countryCode || '46';
        if (ccDisplayEl) ccDisplayEl.value = countryShortByCode((ccEl && ccEl.value) || parsedPhone.countryCode || '46');
        if (telEl && !telEl.value) {
          telEl.value = formatPhoneDisplay((parsedPhone.number || phone || '').replace(/^0+/, ''), (ccEl && ccEl.value) || parsedPhone.countryCode || '46');
        }
      }
      
      // Formatera telefon efter autofyll
      try {
        var telEl = adultCard.querySelector('[data-name="phone"]');
        var ccEl2 = adultCard.querySelector('input[data-name="phoneCountryCode"]');
        if (telEl && telEl.value) telEl.value = formatPhoneDisplay(telEl.value, (ccEl2 && ccEl2.value) || '46');
      } catch(_) {}
    }
    function collect(){
      var items=[];
      list.querySelectorAll('.pf-passenger').forEach(function(card,idx){
        var obj={ type:card.dataset.pfType, index:idx+1 };
        card.querySelectorAll('[data-name]').forEach(function(input){
          var key=input.getAttribute('data-name');
          var val;
          if (input.type === 'checkbox') {
            val = input.checked;
          } else {
            val = (input.value||'').trim();
            if (key === 'phoneCountryCode') val = String(val).replace(/\D+/g, '') || '46';
            if (key === 'phone') val = digitsOnly(val); // spara utan bindestreck/mellanslag
          }
          obj[key]=val;
        });
        // För +46 ska trunkprefix 0 inte skickas med till bokningen
        if (obj.phone && obj.phoneCountryCode === '46') {
          obj.phone = obj.phone.replace(/^0+/, '');
        }
        items.push(obj);
      });
      logPassengerNameSanitization('collect() före sanering', items);
      sanitizePassengerNameFields(items);
      logPassengerNameSanitization('collect() efter sanering', items);
      return items;
    }
    function isComplete(){
      var a=clampNum(adultsInput.value,0,20), c=clampNum(childrenInput.value,0,20), i=clampNum(infantsInput.value,0,20);
      if ((a + c + i) === 0) return false;
      var ok=true;
      list.querySelectorAll('.pf-passenger').forEach(function(card){
        var type=card.dataset.pfType;
        card.querySelectorAll('input, select').forEach(function(el){ if(!el.checkValidity()) ok=false; });
        if(type==='Barn'){
          var ageEl=card.querySelector('[data-name="age"]');
          var n = ageEl ? parseInt(ageEl.value,10) : NaN;
          if(!ageEl || isNaN(n) || n < 2 || n > 12) ok=false;
        }
      });
      return ok;
    }
    function payingCount(){ if (isUMBooking) return clampNum(childrenInput.value,0,20); return clampNum(adultsInput.value,0,20) + clampNum(childrenInput.value,0,20); }
    function updateButtonsState(){
      var p2 = getUrlProps();
      var isXActive = (p2.rbdXActiveSingle === 'true') || (p2.rbdXActiveOutbound === 'true') || (p2.rbdXActiveReturn === 'true');
      var c = clampNum(childrenInput.value, 0, 20);
      var inf = clampNum(infantsInput.value, 0, 20);
      if (isXActive && (c > 0 || inf > 0)) {
        showErrorHtml('VB-X bokningsklass tillåter inte barn eller spädbarn. Vänligen ta bort barn/spädbarn eller välj en annan bokningsklass.');
        if (pfAddBtn) pfAddBtn.disabled = true;
        if (!themeAddBtn) themeAddBtn = findThemeAddButton();
        if (themeAddBtn) { themeAddBtn.disabled = true; themeAddBtn.setAttribute('aria-disabled', 'true'); themeAddBtn.classList.add('is-disabled'); }
        return;
      }
      // Clear X-class child error if no longer applicable
      if (isXActive && c === 0 && inf === 0 && pfErrEl && pfErrEl.style.display !== 'none' && pfErrEl.innerHTML.indexOf('VB-X') !== -1) {
        showError('');
      }
      var ready = isComplete() && payingCount() > 0;
      if (pfAddBtn) pfAddBtn.disabled = !ready;
      if (!themeAddBtn) themeAddBtn = findThemeAddButton();
      if (themeAddBtn) { themeAddBtn.disabled = !ready; themeAddBtn.setAttribute('aria-disabled', ready ? 'false' : 'true'); themeAddBtn.classList.toggle('is-disabled', !ready); }
    }
    function setHiddenProps(items){ var a=clampNum(adultsInput.value,0,20), c=clampNum(childrenInput.value,0,20), i=clampNum(infantsInput.value,0,20); propAdults.value   = String(a); propChildren.value = String(c); propInfants.value  = String(i); propPassengers.value = JSON.stringify(items); }
    function updateQuantityAndTotal(){
      var a=clampNum(adultsInput.value,0,20), c=clampNum(childrenInput.value,0,20), i=clampNum(infantsInput.value,0,20);
      var count = a + c;
      if (!qtyInput) qtyInput = findQuantityInput();
      if (qtyInput) {
        var min = parseInt(qtyInput.getAttribute('min') || '1', 10);
        qtyInput.value = Math.max(count || 0, min);
        qtyInput.dispatchEvent(new Event('input',  { bubbles:true }));
        qtyInput.dispatchEvent(new Event('change', { bubbles:true }));
      }
      // Recalculate base prices for correct display on Mixed (W+Q) or Standard (W+W) trips
      var vStd = findV('Vuxen');
      var priceStd = vStd ? vStd.price : 199500;
      var vQ = findV('QLIMIT');
      var priceQ = vQ ? vQ.price : priceStd;
      var vSen = findV('Reduced') || findV('Senior');
      var priceSen = vSen ? vSen.price : priceStd;
      var vYth = findV('Reduced') || findV('Youth');
      var priceYth = vYth ? vYth.price : priceStd;

      var p2 = getUrlProps();
      var qOut = (p2.rbdQActiveOutbound === 'true');
      var qRet = (p2.rbdQActiveReturn === 'true');
      var kOut = (p2.rbdKActiveOutbound === 'true');
      var kRet = (p2.rbdKActiveReturn === 'true');
      var qSingle = (p2.rbdQActiveSingle === 'true');
      var kSingle = (p2.rbdKActiveSingle === 'true');
      var xOut = (p2.rbdXActiveOutbound === 'true');
      var xRet = (p2.rbdXActiveReturn === 'true');
      var xSingle = (p2.rbdXActiveSingle === 'true');
      
      var isTwoway = isRoundTripBooking();
      var tt2 = (p2.tripType||'').toLowerCase();
      var isSingle = (tt2 === 'single');
      // Get variant prices for campaign
      var vKampanj = findV('Kampanj');
      var kampanjPrice = vKampanj ? vKampanj.price : priceStd;
      
      // Calculate price per leg based on class
      var outboundAdultPrice = priceStd;
      var returnAdultPrice = priceStd;
      var outboundSeniorPrice = priceSen;
      var returnSeniorPrice = priceSen;
      var outboundYouthPrice = priceYth;
      var returnYouthPrice = priceYth;
      var outboundChildPrice = childUnitPriceCents;
      var returnChildPrice = childUnitPriceCents;
      
      // Determine outbound pricing
      if (isSingle) {
        if (kSingle) {
          outboundAdultPrice = kampanjPrice;
          outboundSeniorPrice = kampanjPrice;
          outboundYouthPrice = kampanjPrice;
        } else if (xSingle) {
          outboundAdultPrice = vbxUnitPriceCents;
          outboundSeniorPrice = vbxUnitPriceCents;
          outboundYouthPrice = vbxUnitPriceCents;
        } else if (qSingle) {
          outboundAdultPrice = priceQ;
          outboundSeniorPrice = priceQ;
          outboundYouthPrice = priceQ;
        } else {
          outboundAdultPrice = priceStd;
          outboundSeniorPrice = priceSen;
          outboundYouthPrice = priceYth;
        }
        returnAdultPrice = 0;
        returnSeniorPrice = 0;
        returnYouthPrice = 0;
        returnChildPrice = 0;
      } else if (isTwoway) {
        // Outbound leg
        if (kOut) {
          outboundAdultPrice = kampanjPrice;
          outboundSeniorPrice = kampanjPrice;
          outboundYouthPrice = kampanjPrice;
        } else if (xOut) {
          outboundAdultPrice = vbxUnitPriceCents;
          outboundSeniorPrice = vbxUnitPriceCents;
          outboundYouthPrice = vbxUnitPriceCents;
        } else if (qOut) {
          outboundAdultPrice = priceQ;
          outboundSeniorPrice = priceQ;
          outboundYouthPrice = priceQ;
        } else {
          outboundAdultPrice = priceStd;
          outboundSeniorPrice = priceSen;
          outboundYouthPrice = priceYth;
        }
        
        // Return leg
        if (kRet) {
          returnAdultPrice = kampanjPrice;
          returnSeniorPrice = kampanjPrice;
          returnYouthPrice = kampanjPrice;
        } else if (xRet) {
          returnAdultPrice = vbxUnitPriceCents;
          returnSeniorPrice = vbxUnitPriceCents;
          returnYouthPrice = vbxUnitPriceCents;
        } else if (qRet) {
          returnAdultPrice = priceQ;
          returnSeniorPrice = priceQ;
          returnYouthPrice = priceQ;
        } else {
          returnAdultPrice = priceStd;
          returnSeniorPrice = priceSen;
          returnYouthPrice = priceYth;
        }

        
      }
      
      var effAdultPrice = outboundAdultPrice + returnAdultPrice;
      var effSeniorPrice = outboundSeniorPrice + returnSeniorPrice;
      var effYouthPrice = outboundYouthPrice + returnYouthPrice;
      var effChildPrice = outboundChildPrice + returnChildPrice;

      var paidChildren = c;

            // Rule: 1 Child free per Adult no longer applies. All children are now paying.
            //var paidChildren = Math.max(0, c - a);
      
      // Calculate adult price distribution
      var numReducedAdults = 0;
      var numRegularAdults = a;

      // Check if ANY leg has campaign active for logged in users
      var hasAnyCampaign = false;
      if (isSingle) {
        hasAnyCampaign = kSingle;
      } else if (isTwoway) {
        hasAnyCampaign = (kOut || kRet);
      }
      
      // If campaign is active on any leg, we already calculated prices correctly above
      // But we still need to handle reduced pricing for contact person
      if (!hasAnyCampaign && a > 0) {
        var rActive = false;
        if (isSingle) { rActive = String(p2.rbdRActiveSingle||'').toLowerCase() === 'true'; }
        else {
          var outR = String(p2.rbdRActiveOutbound||'').toLowerCase() === 'true';
          var retR = String(p2.rbdRActiveReturn||'').toLowerCase() === 'true';
          rActive = outR || retR;
        }
        
        if (rActive && isReducedEligible) {
           // Contact person is reduced
           numReducedAdults = 1;
           
           // Check for other reduced adults
           var adultCards = list.querySelectorAll('.pf-passenger[data-pf-type="Vuxen"]');
           // Skip the first one (contact)
           for (var k = 1; k < adultCards.length; k++) {
              var chk = adultCards[k].querySelector('input[data-name="isReduced"]');
              if (chk && chk.checked) {
                 numReducedAdults++;
              }
           }
           
           numRegularAdults = Math.max(0, a - numReducedAdults);
        }
      }

      var reducedPrice = effAdultPrice;
      if (isSeniorCustomer) reducedPrice = effSeniorPrice;
      else if (isYouthCustomer) reducedPrice = effYouthPrice;
      
      var subtotalCents = 0;
      subtotalCents = (numReducedAdults * reducedPrice) + (numRegularAdults * effAdultPrice) + (effChildPrice * paidChildren);

      // Apply discount from URL if it ends with Pxx (percent) or Axxx (amount in SEK) per paying ticket.
      var finalTotalCents = subtotalCents;
      var rawCode = getUrlDiscountCode();
      var parsedDisc = parseSimpleDiscount(rawCode);
      if (parsedDisc && count > 0) {
        var perAdultDiscountCents2 = 0;
        var perChildDiscountCents2 = 0;
        if (parsedDisc.kind === 'percent') {
          var pct = Math.max(0, Math.min(100, parsedDisc.value));
          perAdultDiscountCents2 = Math.round(effAdultPrice * pct / 100);
          perChildDiscountCents2 = Math.round(effChildPrice * pct / 100);
        } else { // amount
          var amtCents = parsedDisc.value * 100;
          perAdultDiscountCents2 = Math.min(amtCents, effAdultPrice);
          perChildDiscountCents2 = Math.min(amtCents, effChildPrice);
        }
        var totalDiscountCents2 = (perAdultDiscountCents2 * a) + (perChildDiscountCents2 * paidChildren);
        finalTotalCents = Math.max(0, subtotalCents - totalDiscountCents2);
        if (discountSummaryEl) {
          var shownCode2 = rawCode || '';
          var parts2 = [];
          if (a > 0 && perAdultDiscountCents2 > 0) parts2.push(a + ' × ' + formatMoney(perAdultDiscountCents2));
          if (paidChildren > 0 && perChildDiscountCents2 > 0) parts2.push(paidChildren + ' × ' + formatMoney(perChildDiscountCents2));
          discountSummaryEl.style.display = 'block';
          discountSummaryEl.innerHTML = 'Rabatt ' + escapeHtml(shownCode2) + ': '
            + '<span class="pf-discount-amount">' + formatMoneySignedNegative(totalDiscountCents2) + '</span>'
            + (parts2.length ? (' (' + parts2.join(' + ') + ')') : '');
        }
      }

      // Beräkna klimatreducering-kostnad
      var climateTotalCents = 0;
      if (climateCheckbox && climateCheckbox.checked) {
        var totalPassengers = a + c;
        var legs = isTwoway ? 2 : 1;
        var climateQuantity = totalPassengers * legs;
        
        // Bestäm pris per enhet baserat på rutt
        var climatePricePerUnit = 16000; // 160 kr i ören (BMA default)
        var origin = (p2.origin || '').toUpperCase();
        var outDir = (p2.outboundDirection || '').toUpperCase();
        var retDir = (p2.returnDirection || '').toUpperCase();
        var dir = (p2.direction || '').toUpperCase();
        
        if (origin === 'GOT' || 
            dir.indexOf('GOT') !== -1 || 
            dir.indexOf('GÖTEBORG') !== -1 ||
            outDir.indexOf('GOT') !== -1 || 
            outDir.indexOf('GÖTEBORG') !== -1 ||
            retDir.indexOf('GOT') !== -1 || 
            retDir.indexOf('GÖTEBORG') !== -1) {
          climatePricePerUnit = 24600; // 246 kr i ören för GOT
        }
        
        climateTotalCents = climateQuantity * climatePricePerUnit;
        
        // Visa pris under checkboxen
        if (climatePriceEl) {
          var pricePerUnitFormatted = formatMoney(climatePricePerUnit);
          var totalFormatted = formatMoney(climateTotalCents);
          climatePriceEl.textContent = pricePerUnitFormatted + ' per resa × ' + climateQuantity + ' = ' + totalFormatted;
          climatePriceEl.style.display = 'block';
        }
      } else {
        if (climatePriceEl) {
          climatePriceEl.style.display = 'none';
        }
      }
      
      // Lägg till klimatreducering i totalsumman
      finalTotalCents += climateTotalCents;

      // Dra av Gotland-rabatt om någon passagerare är verifierad folkbokförd på Gotland
      try {
        var gotlandDelta = computeGotlandDeltaCents();
        if (gotlandDelta > 0) {
          finalTotalCents = Math.max(0, finalTotalCents - gotlandDelta);
          if (gotlandSummaryEl) {
            var nVer = list ? list.querySelectorAll('.pf-passenger[data-pf-gotland-eligible="true"]').length : 0;
            gotlandSummaryEl.style.display = 'block';
            gotlandSummaryEl.innerHTML = 'Gotlandsrabatt' + (nVer > 0 ? ' (' + nVer + ' verifierad' + (nVer === 1 ? '' : 'e') + ')' : '') + ': '
              + '<span class="pf-discount-amount">' + formatMoneySignedNegative(gotlandDelta) + '</span>';
          }
        } else if (gotlandSummaryEl) {
          gotlandSummaryEl.style.display = 'none';
          gotlandSummaryEl.innerHTML = '';
        }
      } catch(_) {}

      if (totalCountEl) totalCountEl.textContent = String(count);
      if (infantsNoteEl) infantsNoteEl.textContent = 'Spädbarn: ' + i + '';
      if (totalPriceEl) totalPriceEl.textContent = (count>0) ? formatMoney(finalTotalCents) : '—';
    }

    // URL → properties helper (result cached — URL params don't change during a page session)
    function getUrlProps(){
      if (_urlProps) return _urlProps;
      var sp = new URLSearchParams(window.location.search);
      // Keys coming from Shopify may encode spaces as '+' in the key name
      function g(k){
        var key1 = 'properties['+k+']';
        var key2 = 'properties['+k.replace(/\s/g, '+')+']';
        var v = sp.get(key1);
        if (v === null) v = sp.get(key2);
        return v || '';
      }
      _urlProps = {
        tripType: g('Trip Type') || '',
        origin: g('Origin') || '',
        direction: g('Direction') || '',
        date: g('Departure Date') || '',
        time: g('Departure Time') || '',
        flight: g('Flight Number') || '',
        outboundDate: g('Outbound Date') || '',
        outboundTime: g('Outbound Time') || '',
        outboundFlight: g('Outbound Flight Number') || '',
        returnDate: g('Return Date') || '',
        returnTime: g('Return Time') || '',
        returnFlight: g('Return Flight Number') || '',
        outboundDirection: g('Outbound Direction') || '',
        returnDirection: g('Return Direction') || '',
        rbdRActiveSingle: g('RBD R Active') || '',
        rbdRActiveOutbound: g('Outbound R Active') || '',
        rbdRActiveReturn: g('Return R Active') || '',
        rbdKActiveSingle: g('RBD K Active') || '',
        rbdKActiveOutbound: g('Outbound K Active') || '',
        rbdKActiveReturn: g('Return K Active') || '',
        rbdQActiveSingle: g('RBD Q Active') || '',
        rbdQActiveOutbound: g('Outbound Q Active') || '',
        rbdQActiveReturn: g('Return Q Active') || '',
        rbdLActiveSingle: g('RBD L Active') || '',
        rbdLActiveOutbound: g('Outbound L Active') || '',
        rbdLActiveReturn: g('Return L Active') || '',
        rbdPActiveSingle: g('RBD P Active') || '',
        rbdPActiveOutbound: g('Outbound P Active') || '',
        rbdPActiveReturn: g('Return P Active') || '',
        rbdYActiveSingle: g('RBD Y Active') || '',
        rbdYActiveOutbound: g('Outbound Y Active') || '',
        rbdYActiveReturn: g('Return Y Active') || '',
        rbdXActiveSingle: g('RBD X Active') || '',
        rbdXActiveOutbound: g('Outbound X Active') || '',
        rbdXActiveReturn: g('Return X Active') || '',
        rbdUActiveSingle: g('RBD U Active') || '',
        rbdUActiveOutbound: g('Outbound U Active') || '',
        rbdUActiveReturn: g('Return U Active') || '',
        bookingSource: g('BookingSource') || ''
      };
      return _urlProps;
    }

    // Get YYYY-MM-DD of the first departure (fallback to URL single/outbound/return or today)
    function getFirstDepartureYMD(){
      try {
        var segs = buildSegmentsFromUrl();
        if (segs && segs.length && segs[0].departureDateTime) {
          return String(segs[0].departureDateTime).slice(0,10);
        }
      } catch(_){ /* ignore */ }
      var p = getUrlProps();
      return (p.date || p.outboundDate || p.returnDate || new Date().toISOString().slice(0,10));
    }

    // Determine if booking is round-trip (tur och retur)
    function isRoundTripBooking(){
      var p = getUrlProps();
      var hasOut = !!(p.outboundDate && p.outboundTime && p.outboundFlight);
      var hasRet = !!(p.returnDate && p.returnTime && p.returnFlight);
      if (hasOut && hasRet) return true;
      var tt = (p.tripType || '').toLowerCase();
      return (tt === 'return' || tt === 'roundtrip' || tt === 'tur-retur' || tt === 'tur och retur');
    }

    function renderTripMini(){
      var box = document.getElementById('pf-trip-mini');
      if (!box) return;
      var p = getUrlProps();
      function esc(t){ return (t||'').replace(/[&<>]/g, function(c){ return ({'&':'&amp;','<':'&lt;','>':'&gt;'}[c]); }); }
      function fmt(date, time){ var d=(date||'').trim(), tm=(time||'').trim(); return (d && tm) ? (d + ' ' + tm) : (d || tm || ''); }
      var isSingle = (p.tripType || '').toLowerCase() === 'single' || (!!p.date && !p.outboundDate && !p.returnDate);
      var html = '';
      if (isSingle && (p.direction || p.date || p.time)){
        html = '<div class="pf-trip-mini__col">'
             +   '<div class="pf-trip-mini__dir">'+esc(p.direction||'')+'</div>'
             +   '<div class="pf-trip-mini__dt">'+esc(fmt(p.date,p.time))+'</div>'
             + '</div>';
      } else if ((p.outboundDate || p.outboundTime || p.outboundDirection) || (p.returnDate || p.returnTime || p.returnDirection)){
        var left = '<div class="pf-trip-mini__col">'
                 +   '<div class="pf-trip-mini__dir">'+esc(p.outboundDirection||'')+'</div>'
                 +   '<div class="pf-trip-mini__dt">'+esc(fmt(p.outboundDate,p.outboundTime))+'</div>'
                 + '</div>';
        var right = (p.returnDirection||p.returnDate||p.returnTime) ? ('<div class="pf-trip-mini__col">'
                 +   '<div class="pf-trip-mini__dir">'+esc(p.returnDirection||'')+'</div>'
                 +   '<div class="pf-trip-mini__dt">'+esc(fmt(p.returnDate,p.returnTime))+'</div>'
                 + '</div>') : '';
        html = left + right;
      }
      box.innerHTML = html;
      box.style.display = html ? 'flex' : 'none';
    }

    // Helpers for booking payload and API auth
    function isoNoTZ(dateStr, timeStr){
      if(!dateStr || !timeStr) return '';
      var parts = (timeStr||'').split(':');
      var hh = (parts[0]||'').padStart(2,'0');
      var mm = (parts[1]||'').padStart(2,'0');
      return dateStr + 'T' + hh + ':' + mm + ':00';
    }
    function addMinutes(dateStr, timeStr, minutes){
      var YMD=(dateStr||'').split('-').map(Number);
      var HM=(timeStr||'').split(':').map(Number);
      if (YMD.length<3 || HM.length<2) return '';
      var dt=new Date(Date.UTC(YMD[0],YMD[1]-1,YMD[2],HM[0],HM[1],0));
      dt.setUTCMinutes(dt.getUTCMinutes()+(Number(minutes)||0));
      function pad(n){ return String(n).padStart(2,'0'); }
      return dt.getUTCFullYear()+'-'+pad(dt.getUTCMonth()+1)+'-'+pad(dt.getUTCDate())+'T'+pad(dt.getUTCHours())+':'+pad(dt.getUTCMinutes())+':00';
    }
    function addRouteMinutes(dateStr, timeStr, originCode, destCode){
      var o=(originCode||'').toUpperCase();
      var d=(destCode||'').toUpperCase();
      // GOT ↔ VBY takes 75 minutes per requirement; others default 35 minutes
      var isGotVby = (o==='GOT' && d==='VBY') || (o==='VBY' && d==='GOT');
      var mins = isGotVby ? 75 : 35;
      return addMinutes(dateStr, timeStr, mins);
    }
    function parseDirection(dir){
      if (!dir) return {origin:'', destination:''};
      // Normalize any '+' (from querystring) to spaces before splitting
      var cleaned = String(dir).replace(/\+/g, ' ');
      // Normalize common arrow separators
      cleaned = cleaned.replace(/\s*(&rarr;|→|->|—>|-›|→)\s*/gi, ' → ');
      var parts = cleaned.split('→').map(function(s){ return s.trim().toUpperCase(); });
      function map(x){
        // Strip any leading/trailing non-letters that may remain
        x = x.replace(/^[^A-ZÅÄÖ]+|[^A-ZÅÄÖ]+$/g, '');
        if (x.indexOf('VISBY')===0 || x==='VBY') return 'VBY';
        if (x.indexOf('BROMMA')===0 || x==='BMA' || x.indexOf('STOCKHOLM')===0) return 'BMA';
        if (x.indexOf('GÖTEBORG')===0 || x==='GOT' || x.indexOf('GOTEBORG')===0) return 'GOT';
        return '';
      }
      if (parts.length===2) {
        var o = map(parts[0]); var d = map(parts[1]);
        return {origin:o, destination:d};
      }
      // Fallback: try to infer based on tokens present
      var up = cleaned.toUpperCase();
      var o2 = up.indexOf('VISBY')!==-1 ? 'VBY' : (up.indexOf('BROMMA')!==-1 || up.indexOf('STOCKHOLM')!==-1 ? 'BMA' : (up.indexOf('GÖTEBORG')!==-1 || up.indexOf('GOTEBORG')!==-1 ? 'GOT' : ''));
      var d2 = (o2==='VBY') ? (up.indexOf('GÖTEBORG')!==-1 || up.indexOf('GOTEBORG')!==-1 ? 'GOT' : (up.indexOf('BROMMA')!==-1 || up.indexOf('STOCKHOLM')!==-1 ? 'BMA' : ''))
               : (o2==='BMA' ? (up.indexOf('VISBY')!==-1 ? 'VBY' : '') : (o2==='GOT' ? (up.indexOf('VISBY')!==-1 ? 'VBY' : '') : ''));
      return {origin:o2, destination:d2};
    }
    function buildSegmentsFromUrl(forceStandard){
      var p=getUrlProps();
      var isSingle = (p.tripType || '').toLowerCase() === 'single';
      var hasSingleKeys = !!(p.direction && p.date && p.time && p.flight);
      
      // Determine global eligibility (contact person) - but we might need per-batch context?
      // Since createBooking is called per batch, we can assume:
      // - batchW called with forceStandard=true -> useReduced=false.
      // - batchR called with forceStandard=false -> useReduced=true.
      // So 'isReducedEligible' global variable matches the intention if forceStandard=false.
      
      // Choose booking class/fare based on URL flags from flightbooker
      var rbdSingle = String(p.rbdRActiveSingle||'').toLowerCase();
      var rbdOut = String(p.rbdRActiveOutbound||'').toLowerCase();
      var rbdRet = String(p.rbdRActiveReturn||'').toLowerCase();
      var rbdQSingle = String(p.rbdQActiveSingle||'').toLowerCase();
      var rbdQOut = String(p.rbdQActiveOutbound||'').toLowerCase();
      var rbdQRet = String(p.rbdQActiveReturn||'').toLowerCase();
      var rbdKSingle = String(p.rbdKActiveSingle||'').toLowerCase();
      var rbdKOut = String(p.rbdKActiveOutbound||'').toLowerCase();
      var rbdKRet = String(p.rbdKActiveReturn||'').toLowerCase();
      var rbdXSingle = String(p.rbdXActiveSingle||'').toLowerCase();
      var rbdXOut = String(p.rbdXActiveOutbound||'').toLowerCase();
      var rbdXRet = String(p.rbdXActiveReturn||'').toLowerCase();
      var rbdUSingle = String(p.rbdUActiveSingle||'').toLowerCase();
      var rbdUOut = String(p.rbdUActiveOutbound||'').toLowerCase();
      var rbdURet = String(p.rbdUActiveReturn||'').toLowerCase();

      if (isSingle || (hasSingleKeys && !(p.outboundDate && p.outboundTime && p.outboundFlight))) {
        var od = parseDirection(p.direction);
        if (!(p.date && p.time && p.flight)) return [];
        var useReduced = (rbdSingle === 'true') && isReducedEligible && !forceStandard;
        var useQ = (rbdQSingle === 'true');
        var useK = (rbdKSingle === 'true');
        var useX = (rbdXSingle === 'true');
        var useU = (rbdUSingle === 'true');
        var bc = 'W'; var fb = 'WEB';
        if (useK) { bc = 'K'; fb = 'KAMPANJ'; }
        if (useX) { bc = 'X'; fb = 'XTRA'; }
        if (useQ) { bc = 'Q'; fb = 'QLIMIT'; }
        if (useReduced) { bc = 'R'; fb = 'REDUCED'; }
        if (useU) { bc = 'U'; fb = 'UM'; } // U (ensamresande barn) wins

        var originCode = od.origin || (p.origin || 'VBY');

        var destCode = od.destination;
        // Direction-based override to ensure VBY↔GOT singles map correctly (override even if previously set)
        try {
          var dirUp = String(p.direction||'').toUpperCase();
          if (originCode === 'VBY' && (dirUp.indexOf('GÖTEBORG') !== -1 || dirUp.indexOf('GOTEBORG') !== -1 || dirUp.indexOf('GOT') !== -1)) {
            destCode = 'GOT';
          } else if (originCode === 'GOT' && (dirUp.indexOf('VISBY') !== -1 || dirUp.indexOf('VBY') !== -1)) {
            destCode = 'VBY';
          }
        } catch(_) {}
        if (!destCode) {
          // Try to infer destination from current product handle/path as a robust fallback
          try {
            var path = String(window.location.pathname||'').toLowerCase();
            if (originCode==='VBY') {
              if (path.indexOf('visby-goteborg')!==-1 || path.indexOf('visby-göteborg')!==-1) destCode = 'GOT';
              else destCode = 'BMA';
            } else if (originCode==='BMA') {
              destCode = 'VBY';
            } else if (originCode==='GOT') {
              if (path.indexOf('goteborg-visby')!==-1 || path.indexOf('göteborg-visby')!==-1) destCode = 'VBY';
              else destCode = 'VBY';
            }
          } catch(_){
            if (originCode==='VBY') destCode = 'BMA';
            else if (originCode==='BMA') destCode = 'VBY';
            else if (originCode==='GOT') destCode = 'VBY';
            else destCode = 'VBY';
          }
        }
        return [{
          flightNumber: String(p.flight),
          departureDateTime: isoNoTZ(p.date, p.time),
          arrivalDateTime: addRouteMinutes(p.date, p.time, originCode, destCode),
          origin: originCode,
          destination: destCode,
          bookingClass: bc,
          fareBasis: fb,
          marketingAirline: 'OJ'
        }];
      }
      var out=parseDirection(p.outboundDirection);
      var ret=parseDirection(p.returnDirection);
      var segs=[];
      if (p.outboundDate && p.outboundTime && p.outboundFlight){
        var useReducedOut = (rbdOut === 'true') && isReducedEligible && !forceStandard;
        var useQOut = (rbdQOut === 'true');
        var useKOut = (rbdKOut === 'true');
        var useXOut = (rbdXOut === 'true');
        var useUOut = (rbdUOut === 'true');
        var bcOut = 'W'; var fbOut = 'WEB';
        if (useKOut) { bcOut = 'K'; fbOut = 'KAMPANJ'; }
        if (useXOut) { bcOut = 'X'; fbOut = 'XTRA'; }
        if (useQOut) { bcOut = 'Q'; fbOut = 'QLIMIT'; }
        if (useReducedOut) { bcOut = 'R'; fbOut = 'REDUCED'; }
        if (useUOut) { bcOut = 'U'; fbOut = 'UM'; }

        var outOrigin = out.origin || (p.origin || 'VBY');

        var outDest = out.destination || (function(){
          if (outOrigin==='VBY') return (out.destination ? out.destination : 'BMA');
          if (outOrigin==='BMA') return 'VBY';
          if (outOrigin==='GOT') return 'VBY';
          return 'VBY';
        })();
        segs.push({
          flightNumber: String(p.outboundFlight),
          departureDateTime: isoNoTZ(p.outboundDate, p.outboundTime),
          arrivalDateTime: addRouteMinutes(p.outboundDate, p.outboundTime, outOrigin, outDest),
          origin: outOrigin,
          destination: outDest,
          bookingClass: bcOut,
          fareBasis: fbOut,
          marketingAirline: 'OJ'
        });
      }
      if (p.returnDate && p.returnTime && p.returnFlight){
        var o2 = (segs[0] && segs[0].destination) || ret.origin || 'BMA';
        var d2 = (segs[0] && segs[0].origin)      || ret.destination || 'VBY';
        var useReducedRet = (rbdRet === 'true') && isReducedEligible && !forceStandard;
        var useQRet = (rbdQRet === 'true');
        var useKRet = (rbdKRet === 'true');
        var useXRet = (rbdXRet === 'true');
        var useURet = (rbdURet === 'true');
        var bcRet = 'W'; var fbRet = 'WEB';
        if (useKRet) { bcRet = 'K'; fbRet = 'KAMPANJ'; }
        if (useXRet) { bcRet = 'X'; fbRet = 'XTRA'; }
        if (useQRet) { bcRet = 'Q'; fbRet = 'QLIMIT'; }
        if (useReducedRet) { bcRet = 'R'; fbRet = 'REDUCED'; }
        if (useURet) { bcRet = 'U'; fbRet = 'UM'; }

        segs.push({
          flightNumber: String(p.returnFlight),

          departureDateTime: isoNoTZ(p.returnDate, p.returnTime),
          arrivalDateTime: addRouteMinutes(p.returnDate, p.returnTime, o2, d2),
          origin: o2,
          destination: d2,
          bookingClass: bcRet,
          fareBasis: fbRet,
          marketingAirline: 'OJ'
        });
      }
      return segs;
    }
    function titleByGender(g){ return g==='Kvinna' ? 'Ms.' : 'Mr.'; }
    function splitPhone(raw, preferredCountryCode){
      var preferred = String(preferredCountryCode||'').replace(/\D+/g,'');
      var local = String(raw||'').replace(/\D+/g,'');
      if (preferred){
        if (preferred === '46') local = local.replace(/^0+/, '');
        return { countryCode: preferred, number: local };
      }
      var s=(raw||'').replace(/[^\d+]/g,'');
      if(!s) return {countryCode:'46', number:''};
      // +CC...
      if (s[0]==='+'){
        var r=s.slice(1);
        for (var len=3; len>=1; len--){
          var cc=r.slice(0,len);
          var rest=r.slice(len);
          if (/^\d{1,3}$/.test(cc) && /^\d+$/.test(rest)) return {countryCode:cc, number:rest.replace(/^0+/, '')};
        }
      }
      // 00CC...
      if (s.startsWith('00')){
        var r2=s.slice(2);
        for (var len2=3; len2>=1; len2--){
          var cc2=r2.slice(0,len2);
          var rest2=r2.slice(len2);
          if (/^\d{1,3}$/.test(cc2) && /^\d+$/.test(rest2)) return {countryCode:cc2, number:rest2.replace(/^0+/, '')};
        }
      }
      // Local (assume Sweden 46)
      return {countryCode:'46', number:s.replace(/^0+/, '')};
    }
    function buildPassengersForApi(collected, contactPassenger, isContactTraveling){
      if (isContactTraveling === undefined) isContactTraveling = true;
      var adults   = collected.filter(function(p){ return p.type==='Vuxen'; });
      var children = collected.filter(function(p){ return p.type==='Barn'; });
      var infants  = collected.filter(function(p){ return p.type==='Spädbarn'; });
      var result=[];
      var depYMD = getFirstDepartureYMD();

      var ctcSource = contactPassenger || (adults.length ? adults[0] : null);
      if (ctcSource) {
        var title=titleByGender(ctcSource.gender);
        var ph=splitPhone(ctcSource.phone||'', ctcSource.phoneCountryCode||'');
        var ctcObj = { type:'CTC', title:title, firstName:sanitizeSwedishNameChars(ctcSource.firstName||'Unknown'), lastName:sanitizeSwedishNameChars(ctcSource.lastName||'Unknown'), phone:{countryCode:ph.countryCode, number:ph.number}, email:ctcSource.email||'' };
        if (!isContactTraveling) {
          ctcObj.suppressDuplication = true;
          ctcObj.isContactTraveling = false;
        }
     
        result.push(ctcObj);
      }

      adults.forEach(function(a){
        var title=titleByGender(a.gender); var ph=a.phone?splitPhone(a.phone, a.phoneCountryCode||''):null;
        var adt = { type:'ADT', title:title, firstName:sanitizeSwedishNameChars(a.firstName||'Unknown'), lastName:sanitizeSwedishNameChars(a.lastName||'Unknown'), phone:ph?{countryCode:ph.countryCode, number:ph.number}:undefined, email:a.email||undefined };
        // Legacy reduced class
        /*
        try {
           if (ctcObj && ctcObj.bookingClass === 'R') { adt.bookingClass = 'R'; adt.fareBasis = 'REDUCED'; }
        } catch(_){}
        */
        result.push(adt);
      });

      children.forEach(function(ch){
        var title=titleByGender(ch.gender);
        // Beräkna födelsedatum (YYYY-MM-DD) från ålder och första avgångsdatum
        var bd = '';
        var age = ch.age ? parseInt(ch.age,10) : NaN;
        if (!isNaN(age) && depYMD && /^\d{4}-\d{2}-\d{2}$/.test(depYMD)){
          var parts = depYMD.split('-');
          var y = parseInt(parts[0],10) - age;
          var m = parts[1];
          var d = parts[2];
          if (isFinite(y)) bd = String(y).padStart(4,'0') + '-' + m + '-' + d;
        }
        var chd = { type:'CHD', title:title, firstName:sanitizeSwedishNameChars(ch.firstName||'Unknown'), lastName:sanitizeSwedishNameChars(ch.lastName||'Unknown') };
        if (bd) chd.birthDate = bd;
        result.push(chd);
      });
      // Lägg till spädbarn (INF) i payloaden men de påverkar inte priset (prissättning hanteras separat via payingCount)
      infants.forEach(function(inf){
        var title=titleByGender(inf.gender);
        // Default birthDate for infants (1 year old) if not collected, to satisfy API requirements
        var bdInf = '';
        if (depYMD && /^\d{4}-\d{2}-\d{2}$/.test(depYMD)){
           var parts = depYMD.split('-');
           var y = parseInt(parts[0],10) - 1; 
           bdInf = String(y).padStart(4,'0') + '-' + parts[1] + '-' + parts[2];
        }
        result.push({ type:'INF', title:title, firstName:sanitizeSwedishNameChars(inf.firstName||'Unknown'), lastName:sanitizeSwedishNameChars(inf.lastName||'Unknown'), birthDate: bdInf });
      });
      return result;
    }
    function utcDateYYYYMMDD(){ return new Date().toISOString().slice(0,10); }
    async function sha256Hex(str){
      var enc = new TextEncoder();
      var data = enc.encode(str);
      var hash = await (window.crypto && crypto.subtle ? crypto.subtle.digest('SHA-256', data) : Promise.reject(new Error('Web Crypto not available')));
      var bytes = Array.from(new Uint8Array(hash));
      return bytes.map(function(b){ return b.toString(16).padStart(2,'0'); }).join('');
    }
    async function buildAuthToken(secret){
      var dateStr = utcDateYYYYMMDD();
      return sha256Hex(dateStr + '+' + (secret||''));
    }
    async function buildAuthTokenForDateStr(secret, dateStr){
      return sha256Hex(String(dateStr) + '+' + (secret||''));
    }
    async function createBooking(collected, bookingClassOverride, contactPassenger, isContactTraveling){
      var forceStandard = (bookingClassOverride === 'W');
      var segments = buildSegmentsFromUrl(forceStandard);
      if(!segments.length) throw new Error('Saknar flightinfo i URL');
      
      // buildSegmentsFromUrl handles all booking classes (K, R, Q, X, W) per segment
      // based on the URL flags (Outbound K Active, Return R Active, etc.).
      // forceStandard=true (when override==='W') only blocks R from the non-reduced batch.
      // For the campaign path (override==='K'), forceStandard=false so mixed K/R bookings
      // like K-outbound + R-return are handled correctly per segment.
      
      logPassengerNameSanitization('createBooking() inkommande collected', collected);
      var passengers = buildPassengersForApi(collected, contactPassenger, isContactTraveling);
      logPassengerNameSanitization('createBooking() payload.passengers', passengers);
      var ctc = passengers.find(function(p){ return p.type==='CTC'; });
      var payload = {
        itinerary: { segments: segments },
        passengers: passengers,
        contact: ctc ? { email: ctc.email||'', phone: ctc.phone||{countryCode:'46', number:''} } : { email:'', phone:{countryCode:'46', number:''} },
        currency: currency || 'SEK'
      };
  var apiBase = 'https://bmaflyg.live2.se';
  // Generate dynamic token same as backend: SHA256(YYYY-MM-DD + '+' + secret)
  var tokenSecret = 'tvsoffataklampaknapputtag2847613kjslfm';
  var token = await buildAuthToken(tokenSecret);
      // Always post to /booking per spec
  // Enable verbose backend response (raw XML and normalized) when ?debug=1 is present
  var debug = false; try { var usp = new URLSearchParams(window.location.search); debug = usp.get('debug') === '1'; } catch(_){ }
  var url = String(apiBase).replace(/\/+$/,'') + '/booking' + (debug ? '?raw=1' : '');
      var r = await fetch(url, {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'Accept':'application/json', 'X-Auth-Token': token },
        body: JSON.stringify(payload),
        credentials:'omit',
        mode:'cors'
      });
      // If unauthorized, retry once with yesterday's token (backend accepts today or yesterday)
      if (r.status === 401) {
        try {
          var yesterday = new Date(Date.now() - 24*60*60*1000).toISOString().slice(0,10);
          var yToken = await buildAuthTokenForDateStr(tokenSecret, yesterday);
          r = await fetch(url, {
            method:'POST',
            headers:{ 'Content-Type':'application/json', 'Accept':'application/json', 'X-Auth-Token': yToken },
            body: JSON.stringify(payload),
            credentials:'omit',
            mode:'cors'
          });
        } catch(_){ }
      }
      if(!r.ok){ throw new Error('Booking API error'); }
      var data = await r.json().catch(function(){ return null; });
      // Support both normal and raw=1 responses from backend
      var norm = (data && data.normalized) ? data.normalized : data;
      
      // FIX: Ensure we get the actual booking reference code (e.g. 6 chars), not a route string or undefined.
      // Prioritize root-level bookingReference if norm seems off.
      var bookingRef = (data && data.bookingReference) ? data.bookingReference : (norm && norm.bookingReference);
      
      // Extra safety: a booking ref should not contain spaces or arrows
      if (bookingRef && (String(bookingRef).length > 10 || String(bookingRef).indexOf(' ') !== -1 || String(bookingRef).indexOf('>') !== -1)) {
          // If the found ref looks like a route description, try strictly the other source
          if (norm && norm.bookingReference && norm.bookingReference !== bookingRef && String(norm.bookingReference).length < 10) {
             bookingRef = norm.bookingReference;
          }
      }

      var ok = (norm && norm._meta && norm._meta.hasReservation);
      // If we have a valid-looking bookingRef, assume success if ok is undefined
      if (bookingRef && ok === undefined) ok = true;

      if(!bookingRef || ok === false) {
        // Try to surface WorldTicket error details if present
        var errMsg = 'Booking not confirmed';
        try {
          if (norm && Array.isArray(norm.errors) && norm.errors.length) {
            var e0 = norm.errors[0] || {};
            var parts = [];
            if (e0.code) parts.push(String(e0.code));
            if (e0.shortText) parts.push(String(e0.shortText));
            if (!e0.shortText && e0.value) parts.push(String(e0.value));
            if (parts.length) errMsg = parts.join(': ');
          } else if (norm && norm.hints && norm.hints.length) {
            errMsg = String(norm.hints[0]);
          }
        } catch(_){}
        throw new Error(errMsg);
      }
      try{ localStorage.setItem('lastBookingResponse', JSON.stringify(data)); }catch(e){}
      return bookingRef;
    }

    function buildLineItemProperties(items){
      var p = getUrlProps();
      var a = items.filter(function(x){return x.type==='Vuxen'}).length;
      var c = items.filter(function(x){return x.type==='Barn'}).length;
      var i = items.filter(function(x){return x.type==='Spädbarn'}).length;
      var props = {};
      if (p.bookingSource) props['BookingSource'] = p.bookingSource;
      props['Adults']     = String(a);
      props['Children']   = String(c);
      props['Infants']    = String(i);
      props['Passengers'] = JSON.stringify(items);
      if (p.tripType) props['Trip Type'] = p.tripType;
      if (p.origin) props['Origin'] = p.origin;

      // Single-trip keys
      if (p.direction) props['Direction'] = p.direction;
      if (p.date) props['Departure Date'] = p.date;
      if (p.time) props['Departure Time'] = p.time;
      if (p.flight) props['Flight Number'] = p.flight;

      // Round-trip keys (if present)
      if (p.outboundDirection) props['Outbound Direction'] = p.outboundDirection;
      if (p.outboundDate) props['Outbound Date'] = p.outboundDate;
      if (p.outboundTime) props['Outbound Time'] = p.outboundTime;
      if (p.outboundFlight) props['Outbound Flight Number'] = p.outboundFlight;

      if (p.returnDirection) props['Return Direction'] = p.returnDirection;
      if (p.returnDate) props['Return Date'] = p.returnDate;
      if (p.returnTime) props['Return Time'] = p.returnTime;
      if (p.returnFlight) props['Return Flight Number'] = p.returnFlight;

      return props;
    }

    async function diagnoseBkError(bkErr) {
      var apiBase = 'https://bmaflyg.live2.se';
      var segs = [];
      try { segs = buildSegmentsFromUrl(); } catch(_) {}

      // 1. Check availability for each segment (same API as flightbooker uses)
      for (var si = 0; si < segs.length; si++) {
        var seg = segs[si];
        var dateStr = seg.departureDateTime ? String(seg.departureDateTime).slice(0, 10) : '';
        if (!dateStr || !seg.origin || !seg.destination) continue;
        try {
          var resp = await fetch(apiBase + '/public/flightlist_db?from=' + encodeURIComponent(seg.origin) + '&to=' + encodeURIComponent(seg.destination) + '&date=' + encodeURIComponent(dateStr));
          if (resp.ok) {
            var avail = await resp.json();
            if (avail && Array.isArray(avail.departures)) {
              var segFlight = String(seg.flightNumber || '');
              var match = avail.departures.find(function(d) {
                var fn = String(d.flightNumber || '');
                // Match against stripped number or full "OJ0801" style
                return fn === segFlight ||
                       fn.replace(/^OJ0*/i, '') === segFlight.replace(/^0+/, '') ||
                       fn.endsWith(segFlight.replace(/^0+/, ''));
              });
              if (match && match.available_seats <= 0) {
                var displayNum = (seg.marketingAirline || 'OJ') + segFlight.replace(/^0+/, '').padStart(4, '0');
                return 'Flight ' + displayNum + ' är tyvärr fullbokad, vänligen gå tillbaka till startsidan och välj en annan tid/datum.';
              }

              // Check if the specific booking class (RBD) used in this segment is full or lacks enough seats
              if (match && seg.bookingClass) {
                var rbd = String(seg.bookingClass).toUpperCase();
                var rbdNames = { W: 'Guld (W)', Q: 'Silver (Q)', R: 'Pensionär (R)', K: 'Kampanj (K)', P: 'Buntbiljett (P)', L: 'GDS (L)', V: 'GDS (V)', X: 'Guld (X)' };
                var rbdLabel = rbdNames[rbd] || rbd;
                var rbdAvailRaw = match['rbd_' + rbd.toLowerCase() + '_available'];
                var displayNum2 = (seg.marketingAirline || 'OJ') + segFlight.replace(/^0+/, '').padStart(4, '0');
                var childOnlyClasses2 = ['R', 'Q', 'K', 'X', 'S', 'U'];
                var needSeats = (typeof payingCount === 'function')
                  ? (childOnlyClasses2.indexOf(rbd) !== -1 ? clampNum(adultsInput.value, 0, 20) : payingCount())
                  : 1;
                if (rbdAvailRaw !== null && rbdAvailRaw !== undefined) {
                  var rbdAvail = parseInt(rbdAvailRaw) || 0;
                  // Fully booked or closed (available=0 from WT already means either)
                  if (rbdAvail === 0) {
                    return 'Tyvärr är prisnivån <strong>' + rbdLabel + '</strong> slutsåld på flight ' + displayNum2 + '. Gå tillbaka och välj ett annat pris eller datum, eller kontakta oss på <a href="mailto:info@brommaflyg.se">info@brommaflyg.se</a>.';
                  }
                  // Not enough seats for the requested number of passengers
                  if (rbdAvail < needSeats) {
                    return 'Tyvärr finns det bara <strong>' + rbdAvail + ' lediga platser</strong> i prisnivån ' + rbdLabel + ' på flight ' + displayNum2 + '. Gå tillbaka och minska antalet passagerare eller välj ett annat datum.';
                  }
                }
              }
            }
          }
        } catch(_) {}
      }

      // 2. Validate request payload data
      var isoDateRx = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/;
      var validationErrors = [];
      for (var si2 = 0; si2 < segs.length; si2++) {
        var s = segs[si2];
        var label = segs.length > 1 ? (si2 === 0 ? 'Utresa' : 'Hemresa') : 'Flyget';
        // Check all required fields have values
        var reqFields = ['flightNumber', 'departureDateTime', 'origin', 'destination', 'bookingClass', 'fareBasis'];
        for (var fi = 0; fi < reqFields.length; fi++) {
          if (!s[reqFields[fi]]) validationErrors.push(label + ': ' + reqFields[fi] + ' saknas');
        }
        // Check date format
        if (s.departureDateTime && !isoDateRx.test(String(s.departureDateTime))) {
          validationErrors.push(label + ': ogiltigt datumformat (' + s.departureDateTime + ')');
        }
        // Check flight number identifier starts with OJ
        var fullId = String(s.marketingAirline || '') + String(s.flightNumber || '');
        if (fullId && !/^OJ/i.test(fullId)) {
          validationErrors.push(label + ': flygplansnummer börjar inte med OJ (' + fullId + ')');
        }
      }
      if (validationErrors.length > 0) {
        return 'Bokningsdata verkar felaktig \u2013 ' + validationErrors.join(', ') + '. V\u00e4nligen g\u00e5 tillbaka och f\u00f6rs\u00f6k igen, eller kontakta oss p\u00e5 <a href="mailto:info@brommaflyg.se">info@brommaflyg.se</a>.';
      }

      var wtCode = '';
      if (bkErr) {
        try { var parsed = JSON.parse(bkErr.message); wtCode = parsed.code || parsed.errorCode || parsed.error || bkErr.message; }
        catch(_) { wtCode = bkErr.message; }
      }

      // Mappa WorldTicket-felkoder till kundvänliga svenska meddelanden.
      // Extrahera bara sifferdelen om wtCode ser ut som "450: Unable to process"
      var wtCodeNum = '';
      if (wtCode) {
        var codeMatch = String(wtCode).trim().match(/^(\d+)/);
        if (codeMatch) wtCodeNum = codeMatch[1];
      }

      var WT_ERROR_MESSAGES = {
        // 1 – Platsbrist / fullbokad
        '1':   'Tyvärr har flighten blivit fullbokad. Vänligen gå tillbaka och välj ett annat datum eller en annan avgång, eller kontakta oss på <a href="mailto:info@brommaflyg.se">info@brommaflyg.se</a> om du behöver hjälp.',
        // 450 – Bokningsklass fullbokad / kan ej behandla bokning
        '450': 'Fel i bokning – en eller flera bokningsklasser är tyvärr redan fullbokade. Vänligen gå tillbaka och välj en annan avgång, eller kontakta oss på <a href="mailto:info@brommaflyg.se">info@brommaflyg.se</a> för hjälp.',
        // 531 – Flyget opererar inte detta datum
        '531': 'Flyget verkar inte operera det valda datumet. Vänligen gå tillbaka och välj ett annat datum, eller kontakta oss på <a href="mailto:info@brommaflyg.se">info@brommaflyg.se</a>.',
        // 69 – Dubbelbokning / bokning finns redan
        '69':  'Det verkar redan finnas en bokning för dessa resenärer på detta flyg. Kontakta oss på <a href="mailto:info@brommaflyg.se">info@brommaflyg.se</a> om du tror att detta är ett fel.',
        // 135 – Ogiltig passagerarinformation
        '135': 'Ogiltig passagerarinformation – kontrollera att namn och uppgifter är korrekt ifyllda och försök igen. Om felet kvarstår, kontakta oss på <a href="mailto:info@brommaflyg.se">info@brommaflyg.se</a>.',
        // 92 – Bokningsgräns nådd
        '92':  'Bokningsgränsen är nådd för det valda alternativet. Kontakta oss på <a href="mailto:info@brommaflyg.se">info@brommaflyg.se</a> för hjälp.',
        // 32 – Systemfel hos WorldTicket
        '32':  'Ett tillfälligt systemfel uppstod. Vänligen försök igen om en stund, eller kontakta oss på <a href="mailto:info@brommaflyg.se">info@brommaflyg.se</a>.',
        // 424 – Ogiltigt datum eller bokningsperiod
        '424': 'Bokningsdatumet är ogiltigt eller utanför tillåten bokningsperiod. Gå tillbaka och välj ett annat datum.',
        // 400 – Felaktig förfrågan
        '400': 'Bokningsförfrågan innehöll felaktiga uppgifter. Vänligen gå tillbaka och försök igen, eller kontakta oss på <a href="mailto:info@brommaflyg.se">info@brommaflyg.se</a>.'
      };

      if (wtCodeNum && WT_ERROR_MESSAGES[wtCodeNum]) {
        return WT_ERROR_MESSAGES[wtCodeNum];
      }

      // Fallback: okänt fel – visa felkoden för support
      return 'Någonting gick fel med din bokning. Vänligen kontakta support på <a href="mailto:info@brommaflyg.se">info@brommaflyg.se</a> och ange:' +
        (wtCode ? ' <code style="background:#f4f4f4;padding:2px 6px;border-radius:4px;font-size:.95em;">' + wtCode + '</code>' : ' felkod ej tillgänglig') + '.';
    }

    // === Hoisted leg/variant helpers (used by both addToCartAjax and Gotland delta calc) ===
    function _isJulyDate(ymd){
      var m = String(ymd || '').match(/^(\d{4})-(\d{2})/);
      return !!m && m[2] === '07';
    }

    function getVariantForLegOuter(passengerType, legClass, legDate) {
      var v = null;
      if (legClass === 'K') v = findV('Kampanj');
      else if (legClass === 'X') v = findV('VB-X');
      else if (legClass === 'R') v = findV('Reduced');
      else if (legClass === 'Q') v = findV('QLIMIT');
      else {
        if (_isJulyDate(legDate)) v = findV('Vuxen-Juli');
        if (!v) v = findV('Vuxen');
      }
      if (!v && legClass === 'R') v = findV('Senior') || findV('Vuxen');
      if (!v && legClass === 'X') v = { id: vbxVariantId, price: vbxUnitPriceCents };
      if (!v) v = { id: adultVariantId, price: adultUnitPriceCents };
      if (passengerType === 'Barn') return { id: childVariantId, price: childUnitPriceCents };
      return v;
    }

    function getClassesForPassengerOuter(isReducedEligibleForPassenger) {
      var res = { out: 'W', ret: 'W' };
      var pp = getUrlProps();
      var ttp = (pp.tripType||'').toLowerCase();
      var kOut = String(pp.rbdKActiveOutbound||pp.rbdKActiveSingle||'').toLowerCase() === 'true';
      var rOut = String(pp.rbdRActiveOutbound||pp.rbdRActiveSingle||'').toLowerCase() === 'true';
      var qOut = String(pp.rbdQActiveOutbound||pp.rbdQActiveSingle||'').toLowerCase() === 'true';
      var xOut = String(pp.rbdXActiveOutbound||pp.rbdXActiveSingle||'').toLowerCase() === 'true';
      var lOut = String(pp.rbdLActiveOutbound||pp.rbdLActiveSingle||'').toLowerCase() === 'true';
      var pOut = String(pp.rbdPActiveOutbound||pp.rbdPActiveSingle||'').toLowerCase() === 'true';
      var yOut = String(pp.rbdYActiveOutbound||pp.rbdYActiveSingle||'').toLowerCase() === 'true';
      if (kOut) res.out = 'K';
      else if (xOut) res.out = 'X';
      else if (rOut && isReducedEligibleForPassenger) res.out = 'R';
      else if (qOut) res.out = 'Q';
      else if (lOut) res.out = 'L';
      else if (pOut) res.out = 'P';
      else if (yOut) res.out = 'Y';
      else res.out = 'W';

      if (ttp.indexOf('single') === -1 && (pp.returnDate || pp.returnFlight)) {
        var kRet = String(pp.rbdKActiveReturn||'').toLowerCase() === 'true';
        var rRet = String(pp.rbdRActiveReturn||'').toLowerCase() === 'true';
        var qRet = String(pp.rbdQActiveReturn||'').toLowerCase() === 'true';
        var xRet = String(pp.rbdXActiveReturn||'').toLowerCase() === 'true';
        var lRet = String(pp.rbdLActiveReturn||'').toLowerCase() === 'true';
        var pRet = String(pp.rbdPActiveReturn||'').toLowerCase() === 'true';
        var yRet = String(pp.rbdYActiveReturn||'').toLowerCase() === 'true';
        if (kRet) res.ret = 'K';
        else if (xRet) res.ret = 'X';
        else if (rRet && isReducedEligibleForPassenger) res.ret = 'R';
        else if (qRet) res.ret = 'Q';
        else if (lRet) res.ret = 'L';
        else if (pRet) res.ret = 'P';
        else if (yRet) res.ret = 'Y';
        else res.ret = 'W';
      } else {
        res.ret = null;
      }
      return res;
    }

    // Applicera Gotland-rabatt på ett cart line item om passageraren är verifierad
    function applyGotlandToCartItem(item, card, passenger) {
      if (!item || !card) return item;
      if (!tripQualifiesForGotlandDiscount()) return item;
      if (card.dataset.pfGotlandEligible !== 'true') return item;
      var gv = gotlandVariantForOriginalId(item.id);
      if (!gv || !gv.id) return item; // ingen matchande variant, behåll original
      item.id = Number(gv.id);
      item.properties = item.properties || {};
      // Line item property header MÅSTE vara 'GotlandId' med värde 'id_{sparRequestId}'
      item.properties['GotlandId'] = 'id_' + (card.dataset.pfGotlandId || '');
      // Namnet på just DEN HÄR passageraren — exakt, inte gissat i efterhand från
      // den delade Passengers-arrayen (som är identisk på alla line items i bokningen).
      item.properties['Passenger First Name'] = (passenger && passenger.firstName) || '';
      item.properties['Passenger Last Name']  = (passenger && passenger.lastName)  || '';
      return item;
    }

    // Beräkna Gotland-rabatt i ören för ett enskilt ben/passagerare.
    // Regler (givna av användaren):
    //   * Ordinarie pris (W, K, X, Y, L, P …)  => 500 kr rabatt
    //   * R (reduced/pensionär) => 500 × (R / W) (proportionellt mot rabatten på W)
    //   * Q (QLIMIT)            => 500 × (Q / K) (proportionellt mot rabatten på K)
    //   * Barn                  => proportionellt mot vuxen-rabatten i samma klass,
    //                              skalad med childPrice / adultPrice
    function gotlandDiscountForLeg(legClass, passengerType, legDate) {
      var FULL = 50000; // 500 kr i ören
      var v = getVariantForLegOuter(passengerType, legClass, legDate);
      var legPrice = (v && typeof v.price === 'number') ? v.price : 0;
      if (legPrice <= 0) return 0;

      if (passengerType === 'Barn') {
        // Barn = alltid baserat på vuxenpris i W-klass, oavsett vilken klass
        // som faktiskt bokats (K/Q/R/X etc. påverkar inte barnrabatten).
        var adultV = getVariantForLegOuter('Vuxen', 'W', legDate);
        var adultPrice = (adultV && typeof adultV.price === 'number') ? adultV.price : 0;
        if (adultPrice > 0) {
          return Math.min(Math.round(FULL * (legPrice / adultPrice)), legPrice);
        }
        return Math.min(FULL, legPrice);
      }

      // Vuxen-rabatt för aktuell klass
      var adultBaseDiscount = FULL;
      if (legClass === 'R') {
        var vW = getVariantForLegOuter('Vuxen', 'W', legDate);
        var vR = getVariantForLegOuter('Vuxen', 'R', legDate);
        var pW = (vW && typeof vW.price === 'number') ? vW.price : 0;
        var pR = (vR && typeof vR.price === 'number') ? vR.price : 0;
        if (pW > 0 && pR > 0) adultBaseDiscount = Math.round(FULL * (pR / pW));
      } else if (legClass === 'Q') {
        var vK = getVariantForLegOuter('Vuxen', 'K', legDate);
        var vQ = getVariantForLegOuter('Vuxen', 'Q', legDate);
        var pK = (vK && typeof vK.price === 'number') ? vK.price : 0;
        var pQ = (vQ && typeof vQ.price === 'number') ? vQ.price : 0;
        if (pK > 0 && pQ > 0) adultBaseDiscount = Math.round(FULL * (pQ / pK));
      }
      // Alla andra klasser (W, K, X, Y, L, P, U): full 500 kr

      return Math.min(adultBaseDiscount, legPrice);
    }

    // Summera Gotland-rabatten över alla verifierade passagerare/ben för UI-sammanställning
    function computeGotlandDeltaCents() {
      if (!hasGotlandVariants() || !list) return 0;
      if (!tripQualifiesForGotlandDiscount()) return 0;
      var pp = getUrlProps();
      var outLegDate = pp.outboundDate || pp.date || '';
      var retLegDate = pp.returnDate || '';
      var delta = 0;
      var cards = list.querySelectorAll('.pf-passenger[data-pf-gotland-eligible="true"]');
      cards.forEach(function(card){
        var type = card.dataset.pfType;
        if (type !== 'Vuxen' && type !== 'Barn') return;
        var isReducedHere = false;
        if (type === 'Vuxen') {
          var rchk = card.querySelector('input[data-name="isReduced"]');
          if (rchk && rchk.checked) isReducedHere = true;
          else {
            var firstAdult = list.querySelector('.pf-passenger[data-pf-type="Vuxen"]');
            if (firstAdult === card && isReducedEligible) isReducedHere = true;
          }
        }
        var classes = getClassesForPassengerOuter(isReducedHere);
        delta += gotlandDiscountForLeg(classes.out, type, outLegDate);
        if (classes.ret) {
          delta += gotlandDiscountForLeg(classes.ret, type, retLegDate);
        }
      });
      return delta;
    }

    async function addToCartAjax(){
      showError('');
      if (!isComplete()) { alert('Vänligen fyll i alla obligatoriska passagerarfält. Barn måste vara mellan 2 och 11 år.'); updateButtonsState(); showSupportBtn(false); return; }
      // Extra skydd: blockera om något barn har ålder utanför 2–12
      var invalidChildAge = Array.prototype.some.call(
        list.querySelectorAll('.pf-passenger[data-pf-type="Barn"] [data-name="age"]'),
        function(el){ var n=parseInt(el.value,10); return isNaN(n) || n < 2 || n > 11; }
      );
      if (invalidChildAge){
        showError('Barn måste vara mellan 2 och 11 år. Justera ålder innan du går vidare.');
        showSupportBtn(false);
        return;
      }

      // Validera X-klass: Max 2 passagerare per flight, och kontrollera att det finns tillräckligt med platser
      var p2 = getUrlProps();
      var xSingle = (p2.rbdXActiveSingle === 'true');
      var xOut = (p2.rbdXActiveOutbound === 'true');
      var xRet = (p2.rbdXActiveReturn === 'true');
      
      if (xSingle || xOut || xRet) {
        var payingPax = payingCount();
        var c = clampNum(childrenInput.value,0,20);
        var i = clampNum(infantsInput.value,0,20);
        
        // Barn och spädbarn får inte bokas på VB-X
        if (c > 0 || i > 0) {
          showErrorHtml('Bokningsklass X tillåter endast vuxna passagerare. Barn och spädbarn kan inte bokas på VB-X. Vänligen välj en annan bokningsklass.');
          showSupportBtn(true);
          pfAddBtn.disabled = false;
          pfAddBtn.textContent = 'Gå vidare till bokning';
          return;
        }
      }

      // GENERELL RBD-KLASSVALIDERING FÖR ALLA KLASSER
      // Kontrollera att det finns tillräckligt med platser i vald bokningsklass före bokningen
      try {
        var apiBase = 'https://bmaflyg.live2.se';
        var segs = buildSegmentsFromUrl();
        var payingPax = payingCount();
        
        var rbdClassNames = {
          'X': 'Guld VB-X',
          'W': 'Guld',
          'Q': 'Silver',
          'R': 'Pensionär',
          'K': 'Kampanj',
          'P': 'Buntbiljett',
          'L': 'GDS',
          'V': 'GDS'
        };
        
        for (var si = 0; si < segs.length; si++) {
          var seg = segs[si];
          var rbd = String(seg.bookingClass || 'W').toUpperCase();
          
          var dateStr = seg.departureDateTime ? String(seg.departureDateTime).slice(0, 10) : '';
          if (!dateStr || !seg.origin || !seg.destination) continue;
          
          var resp = await fetch(apiBase + '/public/flightlist_db?from=' + encodeURIComponent(seg.origin) + '&to=' + encodeURIComponent(seg.destination) + '&date=' + encodeURIComponent(dateStr));
          if (resp.ok) {
            var avail = await resp.json();
            if (avail && Array.isArray(avail.departures)) {
              var segFlight = String(seg.flightNumber || '');
              var match = avail.departures.find(function(d) {
                var fn = String(d.flightNumber || '');
                return fn === segFlight ||
                       fn.replace(/^OJ0*/i, '') === segFlight.replace(/^0+/, '') ||
                       fn.endsWith(segFlight.replace(/^0+/, ''));
              });
              
              if (match) {
                var displayNum = (seg.marketingAirline || 'OJ') + segFlight.replace(/^0+/, '').padStart(4, '0');
                var legLabel = segs.length > 1 ? (si === 0 ? 'utresa' : 'hemresa') : 'flighten';
                
                // Kolla totala platser först (för W eller om RBD inte finns i DB)
                var totalAvail = match.available_seats || 0;
                if (totalAvail <= 0) {
                  showErrorHtml('Flight ' + displayNum + ' (' + legLabel + ') är tyvärr fullbokad. Vänligen välj ett annat datum eller flight.');
                  showSupportBtn(true);
                  pfAddBtn.disabled = false;
                  pfAddBtn.textContent = 'Gå vidare till bokning';
                  return;
                }
                
                // Kolla RBD-klasspecifika platser (available=0 = stängd ELLER slutsåld, direkt från WT)
                var className = rbdClassNames[rbd] || rbd;
                var rbdAvailRaw = match['rbd_' + rbd.toLowerCase() + '_available'];
                
                if (rbdAvailRaw !== null && rbdAvailRaw !== undefined) {
                  var rbdAvail = parseInt(rbdAvailRaw) || 0;
                  
                  // X-klass specialregel: W måste vara stängd/utsåld för att X ska vara giltig
                  if (rbd === 'X') {
                    var wAvail = parseInt(match['rbd_w_available']) || 0;
                    if (wAvail > 0) {
                      showErrorHtml('VB-X bokningsklass är inte tillgänglig eftersom W-klassen (Guld) fortfarande har platser kvar på flight ' + displayNum + '. Gå tillbaka och välj vanlig Guld-biljett.');
                      showSupportBtn(true);
                      pfAddBtn.disabled = false;
                      pfAddBtn.textContent = 'Gå vidare till bokning';
                      return;
                    }
                  }
                  
                  // Helt slutsåld/stängd (available=0)
                  if (rbdAvail === 0) {
                    showErrorHtml('Tyvärr är prisnivån <strong>' + className + '</strong> slutsåld på flight ' + displayNum + ' (' + legLabel + '). Gå tillbaka och välj ett annat pris eller datum, eller kontakta oss på <a href="mailto:info@brommaflyg.se">info@brommaflyg.se</a>.');
                    showSupportBtn(true);
                    pfAddBtn.disabled = false;
                    pfAddBtn.textContent = 'Gå vidare till bokning';
                    return;
                  }
                  
                  // Inte tillräckligt med platser för antal passagerare
                  var childOnlyClasses = ['R', 'Q', 'K', 'X', 'S'];
                  var paxForThisClass = (rbd === 'U')
                    ? clampNum(childrenInput.value, 0, 20) // UM: barn räknas mot kvoten
                    : (childOnlyClasses.indexOf(rbd) !== -1)
                    ? clampNum(adultsInput.value, 0, 20)  // bara vuxna mot denna klass
                    : payingPax;                           // W/övriga: alla passagerare
                  if (rbdAvail < paxForThisClass) {
                    showErrorHtml('Tyvärr finns det bara <strong>' + rbdAvail + ' lediga platser</strong> i prisnivån ' + className + ' på flight ' + displayNum + ' (' + legLabel + '). Du försöker boka ' + paxForThisClass + ' passagerare i denna klass. Gå tillbaka och minska antalet passagerare eller välj ett annat pris/datum.');
                    showSupportBtn(true);
                    pfAddBtn.disabled = false;
                    pfAddBtn.textContent = 'Gå vidare till bokning';
                    return;
                  }
                }
              }
            }
          }
        }
      } catch (err) {
        console.error('RBD-klassvalidering misslyckades:', err);
        // Fortsätt ändå - låt backend validera som fallback
      }

      var qty = payingCount();
      if (qty <= 0) { alert('Minst en betalande biljett (vuxen eller barn) krävs.'); updateButtonsState(); showSupportBtn(false); return; }

      // Blockera ensamresande barn (inga vuxna men minst ett barn eller spädbarn)
      var a = clampNum(adultsInput.value,0,20);
      var c = clampNum(childrenInput.value,0,20);
      var i = clampNum(infantsInput.value,0,20);
      if (!isUMBooking && a === 0 && (c > 0 || i > 0)){
        showErrorHtml('Barn kan tyv\u00e4rr inte bokas ensamma utan medf\u00f6ljande vuxen. V\u00e4nligen kontakta oss p\u00e5 <a href="mailto:info@brommaflyg.se">info@brommaflyg.se</a> s\u00e5 hj\u00e4lper vi dig.');
        showSupportBtn(true);
        pfAddBtn.disabled = false;
        pfAddBtn.textContent = 'Gå vidare till bokning';
        return;
      } else {
        showSupportBtn(false);
      }

      var items = collect();
      sanitizePassengerNameFields(items);
      setHiddenProps(items);

      var originalText = pfAddBtn.textContent; pfAddBtn.disabled = true; pfAddBtn.textContent = 'Skapar bokning...';

      try {
        var contactPassenger = isUMBooking
          ? items.find(function(p){ return p.type === 'Kontaktperson'; })
          : items.find(function(p){ return p.type === 'Vuxen'; });
        var travelingItems = isUMBooking
          ? items.filter(function(p){ return p.type !== 'Kontaktperson'; })
          : items;
        var batchR = [];
        var batchW = [];
        var hasAnyCampaign = false;
        var hasAnyReduced = false;

        var p2 = getUrlProps();
        var tt2 = (p2.tripType||'').toLowerCase();

        if (isUMBooking) {
          // UM mode: all traveling children in one batch, class U handled by URL params
          batchW = travelingItems.slice();
        } else {
        // Check K and R eligibility per leg (not globally)
        var kOutActive = (tt2 === 'single') ? (String(p2.rbdKActiveSingle||'').toLowerCase() === 'true') : (String(p2.rbdKActiveOutbound||'').toLowerCase() === 'true');
        var kRetActive = (tt2 !== 'single') ? (String(p2.rbdKActiveReturn||'').toLowerCase() === 'true') : false;
        
        var rOutActive = (tt2 === 'single') ? (String(p2.rbdRActiveSingle||'').toLowerCase() === 'true') : (String(p2.rbdRActiveOutbound||'').toLowerCase() === 'true');
        var rRetActive = (tt2 !== 'single') ? (String(p2.rbdRActiveReturn||'').toLowerCase() === 'true') : false;

        // For bookings: We book with the MOST RESTRICTIVE class across all legs
        // If any leg is K (and logged in), book as K
        // Else if any leg is R (and eligible), book as R
        // Else book as W
        hasAnyCampaign = (kOutActive || kRetActive) && isLoggedIn;
        hasAnyReduced = (rOutActive || rRetActive) && isReducedEligible;

        if (hasAnyCampaign) {
           // Book all with K class (campaign applies to all legs in the booking)
           batchW = travelingItems.slice();
           // Note: We'll use 'K' as bookingClassOverride
        } else if (hasAnyReduced) {
           travelingItems.forEach(function(p){
              if (p.type === 'Vuxen') {
                 if (p === contactPassenger || p.isReduced) {
                    batchR.push(p);
                 } else {
                    batchW.push(p);
                 }
              } else {
                 // Children/Infants follow the contact person (Reduced group)
                 batchR.push(p);
              }
           });
        } else {
           batchW = travelingItems.slice();
        }
        } // end else (not UM)

        // --- 1. Execute Bookings (Blocking) ---
        // We must perform booking calls BEFORE cart addition.
        // If any booking fails, an error is thrown and we do NOT proceed to cart.
        var bookingRefs = { K: null, R: null, W: null };
        var propsK = {}, propsR = {}, propsW = {};
        
        if (isUMBooking) {
            // UM: contact does NOT travel; children booked as class U (from URL params)
            bookingRefs.W = await createBooking(batchW, null, contactPassenger, false);
            propsW = buildLineItemProperties(batchW);
            propsW['Booking Reference'] = bookingRefs.W;
        // If campaign, book everyone as 'W' but we'll add K class items to cart
        } else if (hasAnyCampaign) {
            bookingRefs.W = await createBooking(batchW, 'K', contactPassenger, true);
            propsW = buildLineItemProperties(batchW);
            propsW['Booking Reference'] = bookingRefs.W;
        } else {
            if (batchR.length > 0) {
                bookingRefs.R = await createBooking(batchR, 'R', contactPassenger, true);
                propsR = buildLineItemProperties(batchR);
                propsR['Booking Reference'] = bookingRefs.R;
            }
            if (batchW.length > 0) {
                var isContactInW = batchW.indexOf(contactPassenger) !== -1;
                bookingRefs.W = await createBooking(batchW, 'W', contactPassenger, isContactInW);
                propsW = buildLineItemProperties(batchW);
                propsW['Booking Reference'] = bookingRefs.W;
            }
        }

        // True om datumsträngen (YYYY-MM-DD) ligger i juli månad
        function isJulyDate(ymd){
           var m = String(ymd || '').match(/^(\d{4})-(\d{2})/);
           return !!m && m[2] === '07';
        }

        // Helper to resolve per-leg variants
        function getVariantForLeg(passengerType, legClass, legDate) {
           // legClass: 'K', 'R', 'Q', 'X', 'W'
           var v = null;
           if (legClass === 'K') v = findV('Kampanj');
           else if (legClass === 'X') v = findV('VB-X');
           else if (legClass === 'R') v = findV('Reduced'); // Senior/Youth map to Reduced
           else if (legClass === 'Q') v = findV('QLIMIT');
           else {
              // W = Standard Adult. Juli-biljetter (avresa i juli) använder dedikerad
              // '-Juli'-variant så att månadsspecifika rabatter kan läggas på.
              if (isJulyDate(legDate)) v = findV('Vuxen-Juli');
              if (!v) v = findV('Vuxen');
           }

           // Fallbacks
           if (!v && legClass === 'R') v = findV('Senior') || findV('Vuxen');
           if (!v && legClass === 'X') v = { id: vbxVariantId, price: vbxUnitPriceCents };
           if (!v) v = { id: adultVariantId, price: adultUnitPriceCents }; // Absolute fallback
           
           if (passengerType === 'Barn') return { id: childVariantId }; // Children use standard child variant
           return v;
        }

        // Determine classes for each leg based on URL and Eligibility
        // Returns { out: 'W', ret: 'Q' } etc.
        function getClassesForPassenger(pObj, isReducedEligibleForPassenger) {
            var res = { out: 'W', ret: 'W' };
            var p = getUrlProps();
            var tt = (p.tripType||'').toLowerCase();
            
            // Outbound Class
            var kOut = String(p.rbdKActiveOutbound||p.rbdKActiveSingle||'').toLowerCase() === 'true';
            var rOut = String(p.rbdRActiveOutbound||p.rbdRActiveSingle||'').toLowerCase() === 'true';
            var qOut = String(p.rbdQActiveOutbound||p.rbdQActiveSingle||'').toLowerCase() === 'true';
            var xOut = String(p.rbdXActiveOutbound||p.rbdXActiveSingle||'').toLowerCase() === 'true';
            var lOut = String(p.rbdLActiveOutbound||p.rbdLActiveSingle||'').toLowerCase() === 'true';
            var pOut = String(p.rbdPActiveOutbound||p.rbdPActiveSingle||'').toLowerCase() === 'true';
            var yOut = String(p.rbdYActiveOutbound||p.rbdYActiveSingle||'').toLowerCase() === 'true';
            
            if (kOut) res.out = 'K';
            else if (xOut) res.out = 'X';
            else if (rOut && isReducedEligibleForPassenger) res.out = 'R';
            else if (qOut) res.out = 'Q';
            else if (lOut) res.out = 'L';
            else if (pOut) res.out = 'P';
            else if (yOut) res.out = 'Y';
            else res.out = 'W';

            // Return Class (if RT)
            if (tt.indexOf('single') === -1 && (p.returnDate || p.returnFlight)) {
                var kRet = String(p.rbdKActiveReturn||'').toLowerCase() === 'true';
                var rRet = String(p.rbdRActiveReturn||'').toLowerCase() === 'true';
                var qRet = String(p.rbdQActiveReturn||'').toLowerCase() === 'true';
                var xRet = String(p.rbdXActiveReturn||'').toLowerCase() === 'true';
                var lRet = String(p.rbdLActiveReturn||'').toLowerCase() === 'true';
                var pRet = String(p.rbdPActiveReturn||'').toLowerCase() === 'true';
                var yRet = String(p.rbdYActiveReturn||'').toLowerCase() === 'true';
                
                if (kRet) res.ret = 'K';
                else if (xRet) res.ret = 'X';
                else if (rRet && isReducedEligibleForPassenger) res.ret = 'R';
                else if (qRet) res.ret = 'Q';
                else if (lRet) res.ret = 'L';
                else if (pRet) res.ret = 'P';
                else if (yRet) res.ret = 'Y';
                else res.ret = 'W';
            } else {
                res.ret = null; // Single trip
            }
            return res;
        }

        // --- Generate Cart Items ---
        var cartPayloadItems = [];

        // Identify which booking ref a passenger belongs to
        function getRefProps(p){
            if (batchR.indexOf(p) !== -1) return propsR;
            if (batchW.indexOf(p) !== -1) return propsW;
            return propsW; // Default to W
        }

        var adults = items.filter(function(x){return x.type==='Vuxen'});
        var children = items.filter(function(x){return x.type==='Barn'});

        // Hämta DOM-kort i samma ordning så vi kan koppla Gotland-status per passagerare
        var adultCardsDom = Array.prototype.filter.call(
          list.querySelectorAll('.pf-passenger'),
          function(c){ return c.dataset.pfType === 'Vuxen'; }
        );
        var childCardsDom = Array.prototype.filter.call(
          list.querySelectorAll('.pf-passenger'),
          function(c){ return c.dataset.pfType === 'Barn'; }
        );

        // Avresedatum per ben (för juli-variant-val)
        var _pDates = getUrlProps();
        var outLegDate = _pDates.outboundDate || _pDates.date || '';
        var retLegDate = _pDates.returnDate || '';
        
        // Add Adults - each leg separately based on URL params
        adults.forEach(function(adult, adultIdx){
           // Check eligibility for reduced pricing
           var isEligible = (adult === contactPassenger && isReducedEligible) || adult.isReduced;
           var classes = getClassesForPassenger(adult, isEligible);
           var pProps = getRefProps(adult);
           var domCard = adultCardsDom[adultIdx] || null;

           var vOut = getVariantForLeg('Vuxen', classes.out, outLegDate);
           
           // Outbound Item
           var outProps = Object.assign({}, pProps);
           outProps['KLASS'] = classes.out;
           outProps['Route'] = p2.outboundDirection || p2.direction;
           cartPayloadItems.push(applyGotlandToCartItem(
             { id: Number(vOut.id), quantity: 1, properties: outProps },
             domCard,
             adult
           ));

           // Return Item
           if (classes.ret) {
              var vRet = getVariantForLeg('Vuxen', classes.ret, retLegDate);
              var retProps = Object.assign({}, pProps);
              retProps['KLASS'] = classes.ret;
              retProps['Route'] = p2.returnDirection;
              cartPayloadItems.push(applyGotlandToCartItem(
                { id: Number(vRet.id), quantity: 1, properties: retProps },
                domCard,
                adult
              ));
           }
        });

        // Add Children - iterera per barn så att Gotland-rabatt kan appliceras individuellt
        if (children.length > 0) {
            // Barnens "klass" bestäms via första barnet (de delar resedata)
            var childClasses = getClassesForPassenger(children[0], false);
            children.forEach(function(child, childIdx){
                var cProps = getRefProps(child);
                var cDomCard = childCardsDom[childIdx] || null;

                var childOutId = childVariantId;
                if (isK) childOutId = campaignChildVariantId;

                var outPropsC = Object.assign({}, cProps);
                outPropsC['KLASS'] = isUMBooking ? 'U' : 'W';
                outPropsC['Route'] = p2.outboundDirection || p2.direction;
                cartPayloadItems.push(applyGotlandToCartItem(
                  { id: Number(childOutId), quantity: 1, properties: outPropsC },
                  cDomCard,
                  child
                ));

                if (childClasses.ret) {
                  var childRetId = childVariantId;
                  if (isK) childRetId = campaignChildVariantId;
                  var retPropsC = Object.assign({}, cProps);
                  retPropsC['KLASS'] = isUMBooking ? 'U' : 'W';
                  retPropsC['Route'] = p2.returnDirection;
                  cartPayloadItems.push(applyGotlandToCartItem(
                    { id: Number(childRetId), quantity: 1, properties: retPropsC },
                    cDomCard,
                    child
                  ));
                }
            });
        }

        // Merge identical items in cartPayloadItems
        var mergedItems = [];
        cartPayloadItems.forEach(function(it){
           var existing = mergedItems.find(function(x){ 
                // Compare ID
                if (x.id !== it.id) return false;
                // Deep compare properties
                var expProps = x.properties || {};
                var itProps = it.properties || {};
                var k1 = Object.keys(expProps).sort();
                var k2 = Object.keys(itProps).sort();
                if (k1.length !== k2.length) return false;
                for (var i=0; i<k1.length; i++) {
                     var k = k1[i];
                     if (k !== k2[i]) return false;
                     if (expProps[k] !== itProps[k]) return false;
                }
                return true;
           });
           if (existing) existing.quantity += it.quantity;
           else mergedItems.push(it);
        });
        
         // Overwrite the cartPayloadItems with merged
        cartPayloadItems = mergedItems;

        try {
          if (window.console && console.log) {
            console.groupCollapsed('[pf-noapi] cart payload line items');
            cartPayloadItems.forEach(function(item, index){
              var props = item.properties || {};
              var passengerList = [];
              try {
                passengerList = props.Passengers ? JSON.parse(props.Passengers) : [];
              } catch(_) {}
              console.log('#' + (index + 1), {
                variantId: item.id,
                quantity: item.quantity,
                klass: props.KLASS,
                route: props.Route,
                passengers: passengerList.map(function(p){
                  return {
                    type: p.type,
                    firstName: p.firstName,
                    lastName: p.lastName,
                    firstNameSanitized: sanitizeSwedishNameChars(p.firstName),
                    lastNameSanitized: sanitizeSwedishNameChars(p.lastName)
                  };
                })
              });
            });
            console.groupEnd();
          }
        } catch(_) {}

        // Lägg till klimatreducering om vald
        if (climateCheckbox && climateCheckbox.checked) {
          var totalPassengers = adults.length + children.length;
          var legs = isRoundTripBooking() ? 2 : 1;
          var climateQuantity = totalPassengers * legs;
          
          // Bestäm vilken variant baserat på rutt
          var climateVariantId = '56558209007947'; // BMA som standard
          var origin = (p2.origin || '').toUpperCase();
          var outDir = (p2.outboundDirection || '').toUpperCase();
          var retDir = (p2.returnDirection || '').toUpperCase();
          var dir = (p2.direction || '').toUpperCase();
          
          // Om GOT förekommer i någon riktning, använd GOT-varianten
          if (origin === 'GOT' || 
              dir.indexOf('GOT') !== -1 || 
              dir.indexOf('GÖTEBORG') !== -1 ||
              outDir.indexOf('GOT') !== -1 || 
              outDir.indexOf('GÖTEBORG') !== -1 ||
              retDir.indexOf('GOT') !== -1 || 
              retDir.indexOf('GÖTEBORG') !== -1) {
            climateVariantId = '56558208975179'; // GOT variant
          }
          
          cartPayloadItems.push({
            id: Number(climateVariantId),
            quantity: climateQuantity,
            properties: { 'Klimatreducering': 'Ja' }
          });
        }

        pfAddBtn.textContent = 'Lägger till i varukorg...';
        var payload = { items: cartPayloadItems };
        var res = await fetch('/cart/add.js', {
          method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify(payload), credentials:'same-origin'
        });
        if(!res.ok){ var t = await res.text().catch(function(){ return ''; }); throw new Error(t || 'Kunde inte lägga till i varukorg.'); }

        if (afterAdd === 'cart') {
          window.location.href = '/cart';
        }
        else if (afterAdd === 'drawer') { document.body.dispatchEvent(new CustomEvent('cart:refresh')); document.body.dispatchEvent(new CustomEvent('cart:open')); pfAddBtn.disabled = false; pfAddBtn.textContent = originalText; }
        else { document.body.dispatchEvent(new CustomEvent('cart:refresh')); pfAddBtn.disabled = false; pfAddBtn.textContent = originalText; }
  } catch(err){
    console.error(err);
    pfAddBtn.disabled = false;
    pfAddBtn.textContent = originalText;
    showSupportBtn(false);
    showError('Kontrollerar orsak till fel...');
    try {
      var diagMsg = await diagnoseBkError(err);
      showErrorHtml(diagMsg);
    } catch(_) {
      showErrorHtml('N\u00e5gonting gick fel med din bokning. V\u00e4nligen kontakta support p\u00e5 <a href="mailto:info@brommaflyg.se">info@brommaflyg.se</a> och ange: <code style="background:#f4f4f4;padding:2px 6px;border-radius:4px;font-size:.95em;">' + (err && err.message ? err.message : 'ok\u00e4nt fel') + '</code>.');
    }
  }
    }

    // ====================================================================
    // === GOTLAND-RABATT: Verifierings-UI (knapp + popup + state) ========
    // ====================================================================
    var _gotlandModal = { overlay:null, rows:null, submitBtn:null, closeBtn:null, statusEl:null, cards:[] };

    function injectGotlandStyles() {
      if (document.getElementById('pf-gotland-styles')) return;
      var s = document.createElement('style');
      s.id = 'pf-gotland-styles';
      s.textContent =
        '.pf-gotland-verify-section{padding:14px 16px;margin:16px 0;background:#f0f4f5;border-left:4px solid #003948;}'
      + '.pf-gotland-verify-hint{margin:0 0 10px;font-size:14px;color:#003948;line-height:1.4;}'
      + '.pf-gotland-verify-btn{background:#003948;color:#fff;border:none;padding:12px 18px;font-weight:600;cursor:pointer;font-size:15px;border-radius:4px;}'
      + '.pf-gotland-verify-btn:hover{background:#005060;}'
      + '.pf-gotland-card-badge{display:inline-flex;align-items:center;gap:8px;background:#067647;color:#fff;padding:4px 10px;font-size:12px;font-weight:700;margin-left:6px;margin-bottom:10px;border-radius:3px;letter-spacing:.3px;}'
      + '.pf-gotland-card-badge--auto{background:#003948;}'
      + '.pf-gotland-badge-remove{background:rgba(255,255,255,.25);border:none;color:#fff;width:18px;height:18px;line-height:16px;border-radius:50%;cursor:pointer;font-size:11px;padding:0;display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;}'
      + '.pf-gotland-badge-remove:hover{background:rgba(255,255,255,.45);}'
      + '.pf-gotland-modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:99999;display:none;align-items:flex-start;justify-content:center;padding:20px;overflow-y:auto;}'
      + '.pf-gotland-modal-overlay.open{display:flex;}'
      + '.pf-gotland-modal-card{width:100%;max-width:720px;background:#fff;border:2px solid #003948;padding:24px;box-shadow:0 8px 26px rgba(0,0,0,.25);margin:auto;}'
      + '.pf-gotland-modal-title{margin:0 0 10px;font-size:22px;color:#003948;}'
      + '.pf-gotland-modal-intro{margin:0 0 14px;font-size:14px;color:#003948;line-height:1.45;}'
      + '.pf-gotland-modal-rows{display:flex;flex-direction:column;gap:10px;margin-bottom:14px;}'
      + '.pf-gotland-modal-row{display:grid;grid-template-columns:1fr 220px;gap:10px;align-items:center;padding:10px;background:#f7f9fa;border:1px solid #d6dee0;}'
      + '.pf-gotland-row-name{font-size:14px;color:#003948;}'
      + '.pf-gotland-row-name small{color:#555;font-weight:normal;}'
      + '.pf-gotland-row-pnr{width:100%;height:40px;border:2px solid #003948;padding:6px 10px;font-size:14px;box-sizing:border-box;outline:none;background:#fff;color:#000;}'
      + '.pf-gotland-row-pnr:focus{border-color:#005060;box-shadow:0 0 0 2px rgba(0,89,96,.15);}'
      + '.pf-gotland-row-result{grid-column:1 / -1;min-height:18px;font-size:13px;}'
      + '.pf-gotland-row-status.approved{color:#067647;font-weight:600;}'
      + '.pf-gotland-row-status.rejected{color:#b42318;font-weight:600;}'
      + '.pf-gotland-row-status.pending{color:#666;font-style:italic;}'
      + '.pf-gotland-modal-status{min-height:20px;margin-bottom:12px;font-size:14px;color:#003948;}'
      + '.pf-gotland-modal-status.error{color:#b42318;}'
      + '.pf-gotland-modal-actions{display:flex;gap:10px;flex-wrap:wrap;}'
      + '.pf-gotland-modal-submit{flex:1;}'
      + '.pf-gotland-modal-close{padding:12px 18px;font-size:14px;background:#f0f4f5;color:#003948;border:1px solid #003948;cursor:pointer;font-weight:600;}'
      + '.pf-gotland-modal-close:hover{background:#e0e8ea;}'
      + '@media (max-width:600px){.pf-gotland-modal-row{grid-template-columns:1fr;}.pf-gotland-modal-actions{flex-direction:column;}.pf-gotland-modal-close{width:100%;}}';
      document.head.appendChild(s);
    }

    function addGotlandBadgeToCard(card) {
      if (!card || card.querySelector('.pf-gotland-card-badge')) return;
      var b = document.createElement('div');
      b.className = 'pf-gotland-card-badge';
      var label = document.createElement('span');
      label.textContent = '\u2713 Gotlandsrabatt aktiverad';
      b.appendChild(label);
      if (card.dataset.pfGotlandAuto === 'true') {
        b.classList.add('pf-gotland-card-badge--auto');
        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'pf-gotland-badge-remove';
        removeBtn.title = 'Ta bort rabatt och betala ordinarie pris';
        removeBtn.setAttribute('aria-label', 'Ta bort Gotlandsrabatt');
        removeBtn.textContent = '\u2715';
        removeBtn.addEventListener('click', function(){ declineAutoGotlandDiscount(card); });
        b.appendChild(removeBtn);
      }
      // Lägg in efter ev. h3-titel
      var h = card.querySelector('h3');
      if (h && h.nextSibling) card.insertBefore(b, h.nextSibling);
      else card.insertBefore(b, card.firstChild);
    }
    function removeGotlandBadgeFromCard(card) {
      if (!card) return;
      var b = card.querySelector('.pf-gotland-card-badge');
      if (b) b.remove();
    }
    // Kunden väljer bort en auto-applicerad Gotland-rabatt (tag '09') och betalar ordinarie pris.
    function declineAutoGotlandDiscount(card) {
      if (!card) return;
      card.dataset.pfGotlandEligible = 'false';
      card.dataset.pfGotlandDeclined = 'true';
      delete card.dataset.pfGotlandAuto;
      delete card.dataset.pfGotlandId;
      removeGotlandBadgeFromCard(card);
      try { updateGotlandVerifyButtonVisibility(); } catch(_){ }
      try { updateButtonsState(); } catch(_){ }
      try { updateQuantityAndTotal(); } catch(_){ }
    }

    // Auto-applicera Gotland-rabatt på första vuxen-kortet (kontaktpersonen)
    // när kunden är inloggad med tag '09' (= folkbokförd på Gotland).
    function autoApplyGotlandToFirstPassenger() {
      if (!isGotlandCustomer || !list || !hasGotlandVariants()) return;
      if (!tripQualifiesForGotlandDiscount()) return;
      var firstAdult = list.querySelector('.pf-passenger[data-pf-type="Vuxen"]');
      if (!firstAdult) return;
      // Skippa om kunden aktivt valt bort rabatten
      if (firstAdult.dataset.pfGotlandDeclined === 'true') return;
      // Skippa om kortet redan är manuellt verifierat eller redan auto-applied
      if (firstAdult.dataset.pfGotlandEligible === 'true') return;
      firstAdult.dataset.pfGotlandEligible = 'true';
      firstAdult.dataset.pfGotlandAuto = 'true';
      // Tillfällig markör tills vi hämtat det riktiga SPAR-UUID:t nedan.
      firstAdult.dataset.pfGotlandId = 'tag09';
      addGotlandBadgeToCard(firstAdult);
      // Kunden taggades '09' vid en tidigare SPAR-verifiering som lagrade ett UUID
      // i spar_customers. Hämta det UUID:t så att line item-propertyn GotlandId
      // blir 'id_<uuid>' istället för 'id_tag09'.
      fetchAndApplyGotlandUuid(firstAdult);
    }

    // Hämtar senaste SPAR-UUID för den inloggade kunden och skriver det till kortets
    // pfGotlandId. Faller tillbaka till 'tag09'-markören om inget UUID hittas.
    function fetchAndApplyGotlandUuid(card) {
      var customerIdRaw = root.getAttribute('data-customer-id') || null;
      var customerId = customerIdRaw ? Number(customerIdRaw) : null;
      if (!customerId || isNaN(customerId)) return;
      try {
        fetch('https://bmaflyg.live2.se/public/gotland-eligibility/uuid-by-customer', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ customerId: customerId })
        }).then(function(r){
          return r.json().catch(function(){ return {}; });
        }).then(function(data){
          var uuid = (data && (data.sparRequestId || data.spar_request_id)) || '';
          // Skriv bara om kortet fortfarande är auto-applied och inte manuellt verifierat.
          if (uuid && card.dataset.pfGotlandAuto === 'true' && card.dataset.pfGotlandEligible === 'true') {
            card.dataset.pfGotlandId = String(uuid);
          }
        }).catch(function(){ /* behåll 'tag09'-fallback */ });
      } catch(_){ /* behåll 'tag09'-fallback */ }
    }

    // Dölj "Verifiera"-knappen om endast 1 passagerare finns och kunden redan auto-applied via tag '09'
    function updateGotlandVerifyButtonVisibility() {
      var section = root.querySelector('#pf-gotland-verify-section');
      if (!section || !list) return;
      var travelerCount = list.querySelectorAll('.pf-passenger[data-pf-type="Vuxen"]').length
                        + list.querySelectorAll('.pf-passenger[data-pf-type="Barn"]').length;
      var firstAdult = list.querySelector('.pf-passenger[data-pf-type="Vuxen"]');
      // Om kunden valt bort auto-rabatten ska knappen ändå visas, så de kan verifiera igen om de ångrar sig.
      var declined = !!(firstAdult && firstAdult.dataset.pfGotlandDeclined === 'true');
      if (isGotlandCustomer && travelerCount <= 1 && !declined) {
        section.style.display = 'none';
      } else {
        section.style.display = '';
      }
    }

    function ensureGotlandVerifyButton() {
      if (!list || !list.parentNode) return;
      if (root.querySelector('#pf-gotland-verify-section')) return;
      if (!hasGotlandVariants()) return; // ingen Gotland-produkt = ingen knapp
      if (!tripQualifiesForGotlandDiscount()) return; // resan ligger utanför rabattperioden
      injectGotlandStyles();
      var section = document.createElement('div');
      section.id = 'pf-gotland-verify-section';
      section.className = 'pf-gotland-verify-section';
      section.innerHTML =
        '<p class="pf-gotland-verify-hint">\u00c4r n\u00e5gon av passagerarna folkbokf\u00f6rd p\u00e5 Gotland? Verifiera nedan f\u00f6r att f\u00e5 rabatterade biljetter.</p>'
      + '<button type="button" id="pf-gotland-verify-btn" class="pf-gotland-verify-btn">Verifiera folkbokf\u00f6ring p\u00e5 Gotland</button>';
      list.parentNode.insertBefore(section, list.nextSibling);
      section.querySelector('#pf-gotland-verify-btn').addEventListener('click', openGotlandModal);
    }

    function ensureGotlandModal() {
      if (_gotlandModal.overlay) return;
      injectGotlandStyles();
      var ov = document.createElement('div');
      ov.className = 'pf-gotland-modal-overlay';
      ov.setAttribute('aria-hidden','true');
      ov.innerHTML =
        '<div class="pf-gotland-modal-card" role="dialog" aria-modal="true" aria-labelledby="pf-gotland-modal-title">'
      +   '<h3 id="pf-gotland-modal-title" class="pf-gotland-modal-title">Verifiera folkbokf\u00f6ring p\u00e5 Gotland</h3>'
      +   '<p class="pf-gotland-modal-intro">Fyll i personnummer f\u00f6r varje passagerare som \u00e4r folkbokf\u00f6rd p\u00e5 Gotland. Verifiering sker mot Skatteverket (SPAR). F\u00f6r varje godk\u00e4nd passagerare appliceras gotlandsrabatten automatiskt p\u00e5 biljetten.</p>'
      +   '<div class="pf-gotland-modal-rows"></div>'
      +   '<div class="pf-gotland-modal-status" aria-live="polite"></div>'
      +   '<div class="pf-gotland-modal-actions">'
      +     '<button type="button" class="pf-gotland-modal-submit pf-add">Verifiera</button>'
      +     '<button type="button" class="pf-gotland-modal-close">St\u00e4ng</button>'
      +   '</div>'
      + '</div>';
      document.body.appendChild(ov);
      _gotlandModal.overlay = ov;
      _gotlandModal.rows = ov.querySelector('.pf-gotland-modal-rows');
      _gotlandModal.submitBtn = ov.querySelector('.pf-gotland-modal-submit');
      _gotlandModal.closeBtn = ov.querySelector('.pf-gotland-modal-close');
      _gotlandModal.statusEl = ov.querySelector('.pf-gotland-modal-status');
      _gotlandModal.submitBtn.addEventListener('click', submitGotlandVerification);
      _gotlandModal.closeBtn.addEventListener('click', closeGotlandModal);
      ov.addEventListener('click', function(e){ if (e.target === ov) closeGotlandModal(); });
      document.addEventListener('keydown', function(e){
        if (e.key === 'Escape' && ov.classList.contains('open')) closeGotlandModal();
      });
    }

    function openGotlandModal() {
      ensureGotlandModal();
      populateGotlandModal();
      _gotlandModal.overlay.classList.add('open');
      _gotlandModal.overlay.setAttribute('aria-hidden','false');
      try { document.body.style.overflow = 'hidden'; } catch(_){ }
      var first = _gotlandModal.rows.querySelector('.pf-gotland-row-pnr');
      if (first) try { first.focus(); } catch(_){ }
    }
    function closeGotlandModal() {
      if (!_gotlandModal.overlay) return;
      _gotlandModal.overlay.classList.remove('open');
      _gotlandModal.overlay.setAttribute('aria-hidden','true');
      try { document.body.style.overflow = ''; } catch(_){ }
    }

    function populateGotlandModal() {
      if (!_gotlandModal.rows) return;
      _gotlandModal.rows.innerHTML = '';
      _gotlandModal.statusEl.textContent = '';
      _gotlandModal.statusEl.classList.remove('error');
      var cards = Array.prototype.filter.call(list.querySelectorAll('.pf-passenger'), function(c){
        var t = c.dataset.pfType;
        return t === 'Vuxen' || t === 'Barn';
      });
      _gotlandModal.cards = cards;
      if (cards.length === 0) {
        _gotlandModal.rows.innerHTML = '<p style="font-size:14px;color:#666;margin:0;">Inga passagerare att verifiera. Fyll i passagerare f\u00f6rst.</p>';
        return;
      }
      var perTypeIdx = { Vuxen: 0, Barn: 0 };
      cards.forEach(function(card){
        var t = card.dataset.pfType;
        perTypeIdx[t] = (perTypeIdx[t] || 0) + 1;
        var typeLabel = t + ' ' + perTypeIdx[t];
        var h = card.querySelector('h3');
        if (h && h.textContent) typeLabel = h.textContent.trim();
        var firstName = ((card.querySelector('[data-name="firstName"]') || {}).value || '').trim();
        var lastName  = ((card.querySelector('[data-name="lastName"]') || {}).value || '').trim();
        var fullName = (firstName + ' ' + lastName).trim();
        var existingPnr = card.dataset.pfGotlandPnr || '';
        var isVerified = card.dataset.pfGotlandEligible === 'true';
        var status = '';
        if (isVerified) status = '<span class="pf-gotland-row-status approved">\u2713 Verifierad</span>';
        else if (card.dataset.pfGotlandEligible === 'false') status = '<span class="pf-gotland-row-status rejected">Inte folkbokf\u00f6rd p\u00e5 Gotland</span>';
        var row = document.createElement('div');
        row.className = 'pf-gotland-modal-row';
        row.innerHTML =
          '<div class="pf-gotland-row-name"><strong>' + escapeHtml(typeLabel) + '</strong>' + (fullName ? '<br><small>' + escapeHtml(fullName) + '</small>' : '') + '</div>'
        // Redan verifierade passagerare f\u00e5r ett l\u00e5st f\u00e4lt \u2013 kan inte skickas in igen.
        + '<input type="text" inputmode="numeric" autocomplete="off" maxlength="13" placeholder="\u00c5\u00c5\u00c5\u00c5MMDDXXXX" class="pf-gotland-row-pnr" value="' + escapeHtml(existingPnr) + '"' + (isVerified ? ' disabled' : '') + '>'
        + '<div class="pf-gotland-row-result">' + status + '</div>';
        _gotlandModal.rows.appendChild(row);
      });

      // Om samtliga passagerare redan \u00e4r verifierade finns inget kvar att skicka.
      var allVerified = cards.every(function(c){ return c.dataset.pfGotlandEligible === 'true'; });
      if (allVerified) {
        _gotlandModal.statusEl.textContent = 'Alla passagerare \u00e4r redan verifierade.';
        _gotlandModal.submitBtn.disabled = true;
      } else {
        _gotlandModal.submitBtn.disabled = false;
      }
    }

    // Normalisera personnummer till en j\u00e4mf\u00f6rbar nyckel (sista 10 siffrorna) s\u00e5
    // att 10- och 12-siffriga varianter av samma nummer matchar varandra.
    function personnummerKey(pnr) {
      return String(pnr || '').replace(/\D+/g, '').slice(-10);
    }

    function submitGotlandVerification() {
      if (!_gotlandModal.rows) return;
      var rows = _gotlandModal.rows.querySelectorAll('.pf-gotland-modal-row');
      var cards = _gotlandModal.cards || [];

      // Inget kvar att verifiera \u2013 blockera helt s\u00e5 vi inte spammar redan godk\u00e4nda passagerare.
      if (cards.length > 0 && cards.every(function(c){ return c.dataset.pfGotlandEligible === 'true'; })) {
        _gotlandModal.statusEl.textContent = 'Alla passagerare \u00e4r redan verifierade.';
        _gotlandModal.submitBtn.disabled = true;
        return;
      }

      var jobs = [];
      for (var i = 0; i < rows.length; i++) {
        var card = cards[i];
        if (card && card.dataset.pfGotlandEligible === 'true') continue; // redan verifierad \u2013 skicka inte igen
        var pnrInput = rows[i].querySelector('.pf-gotland-row-pnr');
        if (!pnrInput) continue;
        var pnr = String(pnrInput.value||'').replace(/\D+/g,'');
        var resCell = rows[i].querySelector('.pf-gotland-row-result');
        if (!pnr) continue; // tom = hoppas \u00f6ver
        if (pnr.length !== 10 && pnr.length !== 12) {
          if (resCell) resCell.innerHTML = '<span class="pf-gotland-row-status rejected">Ogiltigt personnummer</span>';
          continue;
        }
        jobs.push({ row: rows[i], card: card, pnr: pnr, resCell: resCell, key: personnummerKey(pnr) });
      }
      if (jobs.length === 0) {
        _gotlandModal.statusEl.textContent = 'Fyll i personnummer f\u00f6r minst en passagerare.';
        _gotlandModal.statusEl.classList.add('error');
        return;
      }

      // Samma personnummer för inte användas för flera passagerare i samma bokning:
      // varken två rader i samma inskickning, eller en rad vars nummer redan är
      // godkänt på ett ANNAT passagerarkort sedan tidigare.
      var approvedElsewhere = {};
      if (list) {
        list.querySelectorAll('.pf-passenger[data-pf-gotland-eligible="true"]').forEach(function(card){
          var approvedPnr = card.dataset.pfGotlandPnr;
          if (!approvedPnr) return;
          approvedElsewhere[personnummerKey(approvedPnr)] = card;
        });
      }
      var keyCounts = {};
      jobs.forEach(function(job){ keyCounts[job.key] = (keyCounts[job.key] || 0) + 1; });

      var validJobs = [];
      jobs.forEach(function(job){
        var dupInBatch = keyCounts[job.key] > 1;
        var approvedCard = approvedElsewhere[job.key];
        var dupApproved = approvedCard && approvedCard !== job.card;
        if (dupInBatch || dupApproved) {
          if (job.resCell) job.resCell.innerHTML = '<span class="pf-gotland-row-status rejected">Samma personnummer kan inte anv\u00e4ndas f\u00f6r flera passagerare i samma bokning</span>';
          return;
        }
        validJobs.push(job);
      });

      if (validJobs.length === 0) {
        _gotlandModal.statusEl.textContent = 'Inget personnummer kunde skickas \u2013 dubbletter uppt\u00e4ckta.';
        _gotlandModal.statusEl.classList.add('error');
        return;
      }

      _gotlandModal.statusEl.classList.remove('error');
      _gotlandModal.statusEl.textContent = 'Verifierar... v\u00e4nligen v\u00e4nta.';
      _gotlandModal.submitBtn.disabled = true;
      var endpoint = 'https://bmaflyg.live2.se/public/gotland-eligibility/apply';
      var customerEmail = root.getAttribute('data-customer-email') || null;
      var customerIdRaw = root.getAttribute('data-customer-id') || null;
      var customerId = customerIdRaw ? Number(customerIdRaw) : null;
      if (!customerId || isNaN(customerId)) customerId = null;

      var promises = validJobs.map(function(job){
        var resCell = job.row.querySelector('.pf-gotland-row-result');
        if (resCell) resCell.innerHTML = '<span class="pf-gotland-row-status pending">Kontrollerar...</span>';
        return fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            personalNumber: job.pnr,
            customerId: customerId,
            customerEmail: customerEmail,
            tagToApply: 'Gotland'
          })
        }).then(function(r){
          return r.json().catch(function(){ return {}; }).then(function(data){
            return { ok: r.ok, status: r.status, data: data, job: job, resCell: resCell };
          });
        }).catch(function(err){
          return { ok: false, error: err, job: job, resCell: resCell };
        });
      });

      Promise.all(promises).then(function(results){
        var topLevelError = '';
        // Bygg ett kundvänligt felmeddelande; visa väntetid i minuter istället för sekunder.
        function formatSparError(data, fallback){
          var sec = data && Number(data.retryAfterSec);
          if (sec && isFinite(sec) && sec > 0) {
            var min = Math.ceil(sec / 60);
            return 'För många försök mot Statens personadressregister. Vänligen vänta ca ' + min + (min === 1 ? ' minut' : ' minuter') + ' och försök igen.';
          }
          return (data && (data.message || data.error)) || fallback || 'Tekniskt fel';
        }
        results.forEach(function(res){
          var resCell = res.resCell;
          var job = res.job;
          if (res.error || !res.ok) {
            var msg = formatSparError(res.data, res.error && res.error.message);
            if (resCell) resCell.innerHTML = '<span class="pf-gotland-row-status rejected">' + escapeHtml(msg) + '</span>';
            // Spara första riktiga fel (t.ex. rate limit 429) för att visa tydligt överst.
            if (!topLevelError) topLevelError = msg;
            return;
          }
          var data = res.data || {};
          var eligible = !!(data.eligible || data.isEligible || data.success);
          var sparId = data.sparRequestId || data.spar_request_id || data.sparId || data.requestId || '';
          if (eligible) {
            job.card.dataset.pfGotlandEligible = 'true';
            job.card.dataset.pfGotlandId = String(sparId || '');
            job.card.dataset.pfGotlandPnr = job.pnr;
            addGotlandBadgeToCard(job.card);
            if (resCell) resCell.innerHTML = '<span class="pf-gotland-row-status approved">\u2713 Verifierad \u2013 Gotlandsrabatt aktiverad</span>';
          } else {
            job.card.dataset.pfGotlandEligible = 'false';
            delete job.card.dataset.pfGotlandId;
            removeGotlandBadgeFromCard(job.card);
            var rejMsg = (data && (data.message||data.reason)) || 'Inte folkbokf\u00f6rd p\u00e5 Gotland';
            if (resCell) resCell.innerHTML = '<span class="pf-gotland-row-status rejected">' + escapeHtml(rejMsg) + '</span>';
          }
        });
        return topLevelError;
      }).catch(function(){
        return '';
      }).then(function(topLevelError){
        // Rita om modalen: låser precis verifierade rader och sätter rätt
        // submit-knapp-/statusläge (inkl. "alla verifierade") i ett svep.
        populateGotlandModal();
        // Visa ett tydligt felmeddelande överst om något anrop misslyckades (t.ex.
        // "Maximala timgränsen för anrop mot Statens personadressregister är nådd.").
        // Sätts EFTER populateGotlandModal() som annars nollställer statusraden.
        if (topLevelError && _gotlandModal && _gotlandModal.statusEl) {
          _gotlandModal.statusEl.classList.add('error');
          _gotlandModal.statusEl.textContent = topLevelError;
        }
        try { updateButtonsState(); } catch(_){ }
        try { updateQuantityAndTotal(); } catch(_){ }
      });
    }

    // Spara/\u00e5terst\u00e4ll Gotland-state vid omritning av passagerarlistan
    function captureGotlandState() {
      var map = {};
      if (!list) return map;
      var counts = { Vuxen:0, Barn:0, Sp\u00e4dbarn:0, Kontaktperson:0 };
      list.querySelectorAll('.pf-passenger').forEach(function(card){
        var t = card.dataset.pfType || '';
        var idx = counts[t] || 0;
        counts[t] = idx + 1;
        if (card.dataset.pfGotlandEligible || card.dataset.pfGotlandDeclined) {
          map[t + '_' + idx] = {
            eligible: card.dataset.pfGotlandEligible,
            sparId: card.dataset.pfGotlandId || '',
            pnr: card.dataset.pfGotlandPnr || '',
            auto: card.dataset.pfGotlandAuto || '',
            declined: card.dataset.pfGotlandDeclined || ''
          };
        }
      });
      return map;
    }
    function restoreGotlandState(map) {
      if (!list || !map) return;
      var counts = { Vuxen:0, Barn:0, Sp\u00e4dbarn:0, Kontaktperson:0 };
      list.querySelectorAll('.pf-passenger').forEach(function(card){
        var t = card.dataset.pfType || '';
        var idx = counts[t] || 0;
        counts[t] = idx + 1;
        var key = t + '_' + idx;
        var s = map[key];
        if (!s) return;
        card.dataset.pfGotlandEligible = s.eligible;
        if (s.sparId) card.dataset.pfGotlandId = s.sparId;
        if (s.pnr) card.dataset.pfGotlandPnr = s.pnr;
        if (s.auto) card.dataset.pfGotlandAuto = s.auto;
        if (s.declined) card.dataset.pfGotlandDeclined = s.declined;
        if (s.eligible === 'true') addGotlandBadgeToCard(card);
      });
    }

    function populatePassenger(wrapper, data){
      if(!data) return;
      wrapper.querySelectorAll('[data-name]').forEach(function(input){
        var key=input.getAttribute('data-name');
        if (data.hasOwnProperty(key)) {
             if (input.type === 'checkbox') {
                 input.checked = !!data[key];
             } else {
                 input.value = data[key];
             }
        }
      });
    }

    function render(e){
      var source = (e && e.target) ? e.target : null;

      // START CHANGE: Preserve input data
      var saved = collect();
      var savedAdults = saved.filter(function(x){ return x.type==='Vuxen'; });
      var savedChildren = saved.filter(function(x){ return x.type==='Barn'; });
      var savedInfants = saved.filter(function(x){ return x.type==='Spädbarn'; });
      // END CHANGE

      // Spara Gotland-state innan vi rensar listan
      var _gotlandSnapshot = captureGotlandState();
      
      if (e && e.type === 'input' && source && source.value === '') return;

      var aInit = adultsInput && adultsInput.value !== '' ? adultsInput.value : '0'; // Allow 0 temporarily if typing
      var cInit = childrenInput && childrenInput.value !== '' ? childrenInput.value : '0';
      var iInit = infantsInput  && infantsInput.value  !== '' ? infantsInput.value  : '0';
      
      // Max 9 per type
      var a = clampNum(aInit, 0, 9), c = clampNum(cInit, 0, 9), i = clampNum(iInit, 0, 9);
      
      // UM mode: no adults, no infants – only children
      if (isUMBooking) { a = 0; i = 0; if (c < 1 && e && e.type === 'change') c = 1; }
      else
      // Ensure at least 1 adult if not typing
      if (a === 0 && c === 0 && i === 0 && e && e.type === 'change') { a = 1; }

      // Re-calculate totals
      var totalKids = c + i;

      // Max 9 total
      var total = a + totalKids;
      if (total > 9) {
        if (source === adultsInput) { a = Math.max(0, 9 - totalKids); }
        else if (source === childrenInput) { c = Math.max(0, 9 - a - i); }
        else if (source === infantsInput) { i = Math.max(0, 9 - a - c); }
        else {
           // Fallback if source unknown (e.g. initial load with bad values)
           // Reduce in order: Infants -> Children -> Adults
           if (i > 0) { i = Math.max(0, 9 - a - c); }
           if (a + c + i > 9 && c > 0) { c = Math.max(0, 9 - a - i); }
           if (a + c + i > 9 && a > 0) { a = Math.max(0, 9 - c - i); }
        }
      }

      // Only update the input value if it differs from parsed (to avoid cursor jumping)
      // or if it was a 'change' event (blur) to enforce formatting.
      if (adultsInput.value != a) adultsInput.value = a;
      if (childrenInput.value != c) childrenInput.value = c;
      if (infantsInput.value != i) infantsInput.value = i;

      list.innerHTML = '';
      var idx; 
      // UM mode: insert contact person card first (not a traveler)
      if (isUMBooking) {
        var savedContact = saved.find(function(x){ return x.type === 'Kontaktperson'; });
        var contactCard = buildContactCard();
        if (savedContact) populatePassenger(contactCard, savedContact);
        list.appendChild(contactCard);
      }
      for(idx=0; idx<a; idx++){
        var p=buildPassenger('Vuxen', idx+1, { requireAge:false, includeContact: idx===0 });
        if(idx < savedAdults.length) populatePassenger(p, savedAdults[idx]);
        list.appendChild(p);
      }
      for(idx=0; idx<c; idx++){
        var p=buildPassenger('Barn', idx+1, { requireAge:true, includeContact:false });
        if(idx < savedChildren.length) populatePassenger(p, savedChildren[idx]);
        list.appendChild(p);
      }
      for(idx=0; idx<i; idx++){
        var p=buildPassenger('Spädbarn', idx+1, { requireAge:false, includeContact:false });
        if(idx < savedInfants.length) populatePassenger(p, savedInfants[idx]);
        list.appendChild(p);
      }
  // Append required note to last passenger card
      var lastCard = list.lastElementChild;
      if (lastCard) {
        var reqNote = document.createElement('p');
        reqNote.className = 'pf-required-note';
        reqNote.textContent = '* Obligatoriska fält';
        lastCard.appendChild(reqNote);
      }
  try { prefillCustomer(); bindCountryCodeInputs(); bindPhoneMask(); } catch(_){ }
  normalizeAllPhoneFields();
  setTimeout(normalizeAllPhoneFields, 0);
  setTimeout(normalizeAllPhoneFields, 300);
  // Återställ Gotland-verifiering på nybyggda kort (om counts oförändrade per typ)
  try { restoreGotlandState(_gotlandSnapshot); } catch(_){ }
  // Auto-applicera Gotland-rabatt på kontaktpersonen om kunden har tag '09'
  try { autoApplyGotlandToFirstPassenger(); } catch(_){ }
  // Säkerställ att "Verifiera Gotland"-knappen finns efter passagerarlistan
  try { ensureGotlandVerifyButton(); } catch(_){ }
  // Dölj/visa knappen beroende på antal passagerare och kundens tag
  try { updateGotlandVerifyButtonVisibility(); } catch(_){ }
  updateButtonsState(); updateQuantityAndTotal();
      // Återställ support-knapp och fel vid omritning
      showSupportBtn(false);
      showError('');
    }

  [adultsInput, childrenInput, infantsInput].forEach(function(inp){ if(!inp) return; inp.addEventListener('input', render); inp.addEventListener('change', render); });
    if (climateCheckbox) climateCheckbox.addEventListener('change', function(){ updateQuantityAndTotal(); });
    list.addEventListener('input', function(){ updateButtonsState(); updateQuantityAndTotal(); });
    list.addEventListener('change', function(){ updateButtonsState(); updateQuantityAndTotal(); });
    if (pfAddBtn) pfAddBtn.addEventListener('click', addToCartAjax);

    if (productForm){ productForm.addEventListener('submit', function(e){ if (!isComplete() || payingCount() <= 0) { e.preventDefault(); alert('Vänligen fyll i passagerare och välj minst en betalande biljett.'); updateButtonsState(); updateQuantityAndTotal(); } }, true); }

  try {
    // Configure inputs per device
    if (isTouch) setMobileInputs(); else setDesktopInputs();
    // UM mode: hide adults + infants counters, ensure at least 1 child
    if (isUMBooking) {
      var adultsLabel = adultsInput && adultsInput.closest('label');
      if (adultsLabel) adultsLabel.style.display = 'none';
      var infantsLabel = infantsInput && infantsInput.closest('label');
      if (infantsLabel) infantsLabel.style.display = 'none';
      adultsInput.value = '0';
      infantsInput.value = '0';
      if (!childrenInput.value || childrenInput.value === '0') childrenInput.value = '1';
    }
    renderTripMini(); render(); updateButtonsState(); updateQuantityAndTotal();
  }
    catch(err){ console.error(err); showErrorHtml('Tekniskt fel i formul\u00e4ret. Ladda om sidan eller kontakta oss p\u00e5 <a href="mailto:info@brommaflyg.se">info@brommaflyg.se</a>.'); }

    var moTarget = productForm || document.body;
    var mo = new MutationObserver(function(){ var prevThemeBtn = themeAddBtn; var prevQty = qtyInput; themeAddBtn = findThemeAddButton(); qtyInput = findQuantityInput(); if ((themeAddBtn && themeAddBtn !== prevThemeBtn) || (qtyInput && qtyInput !== prevQty)) { updateButtonsState(); updateQuantityAndTotal(); } });
    mo.observe(moTarget, { childList:true, subtree:true, attributes:true });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot, { once:true }); } else { boot(); }
  document.addEventListener('shopify:section:load', boot); document.addEventListener('shopify:section:select', boot);
})();